import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Container,
  Grid,
  IconButton,
  List,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CompanyAndUsersData } from "../../actions/CompanyAndUsers";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import { SummaryAction } from "../../actions/summary";
import TopViewNav from "../CommonComponents/TopViewNav";
import "./Company.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import ViewCompanyPremisson from "./ViewCompanyPremisson";
import Tooltip from "@mui/material/Tooltip";
import Companywiseclientstatus from "../ Companywiseclientstatus/ Companywiseclientstatus";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { dynamiceForm } from "../../actions/DynamiceForm";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import ClientPermissionConfiguration from "./ClientPermissionConfiguration";
import { PermissionMasterAction } from "../../actions/PermissionMaster";
import OrderManagementConfiguration from "./OrdermanagementConfiguration";
import BankDetailsConfiguration from "./BankDetailsConfiguration";
import CameraConfiguration from "./CameraConfiguration";
import DefaultMeetingConfiguration from "./DefaultMeetingConfiguration";
import OdRestoreConfiguration from "./OdRestoreConfiguration";
import OrderManagementHeaderConfiguration from "./OrderManagementHeaderConfiguration";
import MultiLevelApproverConfiguration from "./MultiLevelApproverConfiguration";
import UserEnableDisableConfiguration from "./UserEnableDisableConfiguration";
import CompanyWiseApiDataSync from "./CompanyWiseApiDataSync";
import UnderTakingFormUpload from "./UnderTakingFormUpload";
import GpsNotificationConfiguration from "./GpsNotificationConfiguration";
import UserGpsNotificationConfiguration from "./UserGpsNotificationConfiguration";
import GeofenceDistanceConfiguration from "./GeofenceDistanceConfiguration";
import UserLoginConfiguration from "./UserLoginConfiguration";
import UserReimbursement from "./UserReimbursement";
import DeviceRestoreConfiguration from "./DeviceRestoreConfiguration";
import CompanyAdsConfiguration from "./CompanyAdsConfiguration";
import OdRestorationConfiguration from "./OdRestorationConfiguration";
import UserSitePermission from "./UserSitePermission";
import { initialState, reducer } from "./Utils";
import { useReducer } from "react";

function ConfiguartionUpdate() {
  const navigate = useNavigate();

  const [state, dispatch] = useReducer(reducer, initialState);

  const [companyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [userList, setUserList] = useState([]);

  console.log("userListssssss", userList);
  const [userId, setUserId] = useState({});
  const [usersId, setUsersId] = useState({});
  const [standLiveUserId, setStandLiveUserId] = useState({});
  const [AutoSelectUser, setAutoSelectUser] = useState();
  const [companyId, setCompanyId] = useState();
  const [siteId, setSiteId] = useState();
  const [meetingStart, setMeettingStart] = useState(false);
  const [AttendanceStart, setAttendanceStart] = useState(false);
  const [AllclinetView, setAllclinetView] = useState(false);
  const [singleMetting, setSingleMetting] = useState(false);
  const [switchBtn, setSwitchBtn] = useState(true);
  const [geofanceLat, setGeofancelat] = useState("");
  const [geofanceLong, setGeofancelong] = useState("");
  const [geofanceDistance, setGeofanceDistance] = useState("");
  const [geofanceLatEnd, setGeofancelatEnd] = useState("");
  const [geofanceLongEnd, setGeofancelongEnd] = useState("");
  const [geofanceDistanceEnd, setGeofanceDistanceEnd] = useState("");
  const [locationActiveActual, setLocationActiveActual] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [ModalType, setModalType] = useState("");
  const [GeofanceUserId, setGeofanceUserId] = useState({});
  const [AttendanceShowPremison, setAttendanceShowPremison] = useState([]);
  const [geofanceShowPremison, setgeoFanceShowPremison] = useState([]);
  const [CompanyConfigurationData, setCompanyConfigurationData] = useState([]);
  console.log("CompanyConfigurationData: ", CompanyConfigurationData);
  const [toggleData, setToggleData] = useState();
  const [AttendensSelectTypeId, setAttendensSelectTypeId] = useState({});
  const [FixedOrderStataus, setFixedOrderStataus] = useState(false);
  const [showLocalityOnOrder, setShowLocalityOnOrder] = useState(false);
  const [enableUnitConversion, setEnableUnitConversion] = React.useState(false);
  const [allowOrderWithDecimal, setAllowOrderWithDecimal] =
    React.useState(false);
  const [gstAndPan, setGstAndPan] = React.useState(false);
  const [isWhatsApp, setIsWhatsApp] = React.useState(false);
  const [isBankDetails, setIsBankDetails] = React.useState(false);
  const [isDefaultMeeting, setIsDefaultMeeting] = React.useState(false);
  const [isRemarkEnableForDefaultMeeting, setIsRemarkEnableForDefaultMeeting] =
    React.useState(false);
  const [
    isMeetingSubmissionPushNotification,
    setIsMeetingSubmissionPushNotification,
  ] = React.useState(false);
  const [isGpsLossNotification, setIsGpsLossNotification] =
    React.useState(false);
  const [isShiftCompletionNotification, setIsShiftCompletionNotification] =
    React.useState(false);
  const [isExpenseBulkApprove, setIsExpenseBulkApprove] = React.useState(false);
  const [isMultipleFormForClient, setIsMultipleFormForClient] =
    React.useState(false);
  const [isReimbursementAccess, setIsReimbursementAccess] =
    React.useState(false);
  const [isAddClientWeb, setIsAddClientWeb] = React.useState(false);
  const [sortedList, setSortedList] = useState([]);
  const [OnyShowHeader, setOnyShowHeader] = useState(false);
  const [BackWordStatus, setBackWordStatus] = useState(false);
  const [FinalStatus, setFinalStatus] = useState(false);
  const [companyIdByBtn, setCompanyIdByBtn] = useState();
  const [siteIdByBtn, setSiteIdByBtn] = useState();
  console.log("siteIdByBtn : ", siteIdByBtn);
  const [headerName, setHeaderName] = useState([]);
  const [editeValue, setEditValue] = useState(null);
  const [showEditValue, setShowEdite] = useState(false);
  const [statausValue, setStatausValue] = useState();
  const [AddTitleValue, setAddTitleValue] = useState(false);
  const [standLiveActive, setStandLiveActive] = useState(false);
  const [userListByCompany, setUserListByCompany] = useState([]);
  const [userListByCompanyForAttendance, setUserListByCompanyForAttendance] =
    useState([]);
  const [distanceEndTime, setDistanceEndTime] = useState(
    moment(new Date()).format("hh:mm"),
  );
  const [distanceCalculate, setDistanceCalculate] = useState(false);
  const [locationActive, setLocationActive] = useState(false);
  const [locationEndTime, setLocationEndTime] = useState();
  const [whatsappConfigurationFormData, setWhatsappConfigurationFormData] =
    useState({
      maxMonthLimit: 0,
      maxMonthLimitReadOnly: 0,
      currentMonthLimit: 0,
      lastSentOn: "",
      fromDate: "",
      toDate: "",
      counts: 0,
    });

  console.log("whatsappConfigurationFormData: ", whatsappConfigurationFormData);
  const [isMultiLevelApprover, setIsMultiLevelApprover] = React.useState(false);
  const [enableUndertakingForm, setEnableUndertakingForm] = useState(false);
  const [showGPSLoationStatus, setShowGPSLoationStatus] = useState(false);
  const [showUserLoginPermissionConfig, setShowUserLoginPermissionConfig] =
    useState(false);
  const [showAudioOption, setShowAudioOption] = useState(false);
  const [showActualPath, setShowActualPath] = useState(false);
  const [showLiveTracking, setShowLiveTracking] = useState(false);
  const [
    enableLiveTrackingOnOdWithoutMeeting,
    setEnableLiveTrackingOnOdWithoutMeeting,
  ] = useState(false);
  const [showRouteAndResponse, setShowRouteAndResponse] = useState(false);

  const [isBackgroundServiceEnable, setIsBackgroundServiceEnable] =
    useState(false);

  const [isCompanyWiseApiDataSync, setIsCompanyWiseApiDataSync] =
    useState(false);

  const [singleDeviceLoginPermission, setSingleDeviceLoginPermission] =
    useState(false);

  const [enableAdsConfig, setEnableAdsConfig] = useState(false);

  const [
    isImageUploadEnableInDefaultMeeting,
    setIsImageUploadEnableInDefaultMeeting,
  ] = useState(false);
  const [
    enableMultipleTrackingDataForSingleDay,
    setEnableMultipleTrackingDataForSingleDay,
  ] = useState(false);
  const [odometerReadingRequiredOnOd, setOdometerReadingRequiredOnOd] =
    useState(false);
  const [enableSiteConfiguration, setEnableSiteConfiguration] = useState(false);
  const [originalEnableSiteConfiguration, setOriginalEnableSiteConfiguration] =
    useState(false);
  console.log(
    "originalEnableSiteConfiguration : ",
    originalEnableSiteConfiguration,
  );
  const [
    enableScheduleMeetingBulkApprove,
    setEnableScheduleMeetingBulkApprove,
  ] = useState(false);
  const [enableSubDepartment, setEnableSubDepartment] = useState(false);
  const [enableHrmsDepartment, setEnableHrmsDepartment] = useState(false);
  const [enableOdRestrictionsOnWeekOffs, setEnableOdRestrictionsOnWeekOffs] =
    useState(false);
  const [enableOdRestoration, setEnableOdRestoration] = useState(false);

  const [
    enableMeetingAutoSubmitAfterCertainDistance,
    setEnableMeetingAutoSubmitAfterCertainDistance,
  ] = useState(false);
  const [
    enableCompanyPermissionConfiguration,
    setEnableCompanyPermissionConfiguration,
  ] = useState(false);
  const [enableGeofenceManagement, setEnableGeofenceManagement] =
    useState(false);
  const [userLoginPermissionCacheuster, setUserLoginPermissionCacheuster] =
    useState(new Date());

  const [
    isMeetingSubmitWithoutLocationRestriction,
    setIsMeetingSubmitWithoutLocationRestriction,
  ] = useState(false);

  const [isCompanyWiseMeetingDataSync, setIsCompanyWiseMeetingDataSync] =
    useState(false);

  const selectCompanyId =
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
    JSON.parse(localStorage.getItem("CompanyIdSelect")).id;

  // const [meetingStartvalue, setMeettingStartvalue] = useState()
  // const [AttendanceStartvalue, setAttendanceStartvalue] = useState()
  // const [AllclinetViewvalue, setAllclinetViewvalue] = useState()
  // const [singleMettingvalue, setSingleMettingvalue] = useState()

  //  let ConfigurationList=[
  //   {sno:1 ,name:"Meeting start and End option for duration" ,active:false},
  //   {sno:2 ,name:"Schedule meeting follow up with date or without datetime"},
  //   {sno:3 ,name:"All client or own client view"},
  //   {sno:4 ,name:"Single meeting distance"},
  //   {sno:5 ,name:"None BackWord"},
  //   {sno:6 ,name:"Can change From Final Status"},
  //   {sno:7 ,name:"Can Change only One Level"},
  // ]

  const AttendensSelectType = [
    { type: true, name: "Attendence Both App" },
    { type: false, name: "Attendence Only by Our App" },
  ];

  const openGefeanceModal = (type) => {
    if (companyId === undefined || companyId === null) {
      alert("Please Select Company!");
      return false;
    }

    if (type === "Attendance") {
      fetchAttendancePremisonList();
    }
    if (type === "Geofence") {
      fetchGeofancePremisonList();
    }
    setModalType(type);
    setOpenModal(true);
  };

  const AttendanceHnadler = (e) => {
    setAttendanceStart(e.target.checked);
  };
  const mettintingstarthandler = (e) => {
    setMeettingStart(e.target.checked);
  };

  const fetchCompanyList = async () => {
    const res = await CompanyAndUsersData.fetchCompanyAndUserList();
    if (res !== null) {
      setCompanyList(res.data);
    } else {
      setCompanyList([]);
    }
  };

  const fetchOwnerList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const data = {
      hrmsUserId: hrmsID && hrmsID,
      userId: JSON.parse(localStorage.getItem("data")).id,
      siteId: siteId?.id || null,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      console.log(res);
      setUserList(res.data);
    } else {
      setUserList([]);
    }
  };

  const fetchCompanyWiseSiteList = async () => {
    const data = {
      companyId: companyId ? companyId.id : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
    };
    const res = await companyWiseEmp.getAllCompanyWiseSite(data);
    if (res !== null) {
      console.log(res);
      setSiteList(res.data);
    } else {
      setSiteList([]);
    }
  };
  console.log(
    "setOriginalEnableSiteConfiguration : ",
    companyId?.id,
    companyIdByBtn,
    originalEnableSiteConfiguration,
  );
  const fetchClientBaseEmp = () => {
    if (companyId === undefined || companyId === null) {
      alert("Please Select Company!");
      return false;
    }
    // if (companyId?.isSiteConfigEnabled && !siteId) {
    //   alert("Please Select Site!");
    //   return;
    // }
    localStorage.setItem(
      "CompanyIdSelect",
      JSON.stringify({
        id: companyId.id,
        CompanyName: companyId.companyName,
        site: siteId,
      }),
    );
    setCompanyIdByBtn(companyId.id);
    setSiteIdByBtn(siteId);
    // localStorage.removeItem("CompanyIdSelect")
    fetchUsersListBySelectedCompany();
    fetchUsersListBySelectedCompanyForAttendance();
    fetchcompanyclientstatusDataList();
    getTempalte();
    setOnyShowHeader(true);
    fetchGetWhatsappConfiguration();
    if (showUserLoginPermissionConfig) {
      setUserLoginPermissionCacheuster(new Date());
    }
    const data = {
      companyId: companyId ? companyId.id : null,
      siteId: siteId ? siteId?.id : null,
    };
    companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
      if (response !== null) {
        setCompanyConfigurationData(response.data);

        const mettingstart =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "Meeting start and End option for duration",
          );
        const Schedule =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "Schedule meeting follow up with date or without datetime",
          );
        const Allclient =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "All client or own client view",
          );
        const singleMetting =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "Single meeting distance",
          );
        console.log(mettingstart, "mettingstart");

        const backWord =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "is One step back allowed",
          );
        const finalchange =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "is Final state Editable",
          );
        const oneLevelChange =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "Fixed order of status",
          );

        const distance =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "User Location Tracking Logic",
          );

        const location =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "Location Tracking Interval",
          );

        const localityShowOnOrder =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "LOCALITY_SHOW_ON_ORDER_CREATE",
          );

        const unitConversionEnable =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "UNIT_CONVERSION_VISIBILITY",
          );

        const allowOrderWithDecimalToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ALLOW_ORDER_WITH_DECIMALS",
          );

        const gstAndPanToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "GSTIN_AND_PAN_MANDETORY",
          );

        const whatsAppToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "WHATSAPP_ENABLE",
          );

        const isBankDetailsToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ACCOUNT_DETAILS_SHOW_ON_INVOICE_PAGE",
          );

        const isDefaultMeetingToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "DEFAULT_MEETING_CONFIGURATION",
          );

        const multiLevelApproverToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "COMPANY_WISE_MULTILEVEL_APPROVER",
          );

        const isExpenseBulkApproveToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "EXPENSE_BULK_APPROVE",
          );

        const enableUndertakingFormToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_UNDERTAKING_FORM",
          );

        const showGPSLocationStatusToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "GPS_LOCATION_STATUS",
          );

        const isRemarkEnableForDefaultMeetingToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "IS_REMARK_ENABLE_IN_DEFAULT_MEETING",
          );

        const isMeetingSubmissionPushNotificationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "MEETING_SUBMISSION_PUSH_NOTIFICATION",
          );

        const isGpsLossNotificationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "ENABLE_GPS_LOSS_NOTIFICATION",
          );

        const isShiftCompletionNotificationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_SHIFT_COMPLETION_NOTIFICATION",
          );

        const userLoginPermissionConfigurationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "SFA_LOGIN_PERMISSION_CONFIG",
          );
        const showAudioOptionToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "AUDIO_CONFIGURATION_ENABLED",
          );

        const isMultipleFormForClientToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "ENABLE_MULTIPLE_FORM_FOR_CLIENT",
          );

        const isReimbursementAccessToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_REIMBERSUMENT_CONFIGURATION",
          );

        const isAddClientWebToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_ADD_CLIENT_ON_WEB",
          );

        const showActualPathToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "SHOW_ACTUAL_PATH",
          );

        const showLiveTrackingToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "LIVE_TRACKING",
          );

        const enableLiveTrackingOnOdWithoutMeetingToShow =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "OD_LIVE_TRACKING_NO_MEETING",
          );

        const showRouteAndResponseToShow =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "MEETING_WISE_ROUTE_CREATION",
          );

        const backgroundServiceEnableToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "BACKGROUND_SERVICE_ENABLED",
          );

        const syncCompanyApiData =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "THIRD_PARTY_API_SYNC_FOR_CLIENT",
          );

        const singleDeviceLoginPermissionToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "SINGLE_DEVICE_LOGIN_PERMISSION",
          );

        const meetingSubmissionWithoutLocationRestriction =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "MEETING_SUBMIT_WITHOUT_LOCATION_RESTRICTION",
          );

        const enableAdsConfigToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_ADS_CONFIGURATION",
          );

        const isImageUploadEnableInDefaultMeetingToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "IS_IMAGE_UPLOAD_ENABLE_IN_DEFAULT_MEETING",
          );

        const enableMultipleTrackingDataForSingleDayToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_MULTIPLE_TRACKING_DATA_FOR_SINGLE_DAY",
          );

        const odometerReadingRequiredOnOdToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "ODOMETER_READING_REQUIRED_ON_OD",
          );
        const enableSiteConfigurationToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_SITE_CONFIG",
          );
        const enableScheduleMeetingBulkApproveToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "SCHEDULE_MEETING_BULK_IMPORT",
          );
        const enableHrmsDepartmentToShow =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_HRMS_DEPARTMENT",
          );
        const enableSubDepartmentToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_SUB_DEPARTMENT",
          );
        const enableOdRestrictionsOnWeekOffsToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "OD_RESTRICTIONS_ON_WEEKOFFS",
          );
        const enableOdRestorationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "ENABLE_OD_RESTORATION_PERMISSION",
          );
        const enableCompanyPermissionConfigurationToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "COMPANY_PERMISSION_CONFIGURATION",
          );
        const enableMeetingAutoSubmitAfterCertainDistanceToSet =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "MEETING_AUTO_SUBMIT_AFTER_CERTAIN_DISTANCE",
          );

        const enableGeofenceManagementToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_GEOFENCE_MANAGEMENT",
          );

        const enableMeetingwiseDataSync =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_COMPANY_WISE_MEETING_DATA_SYNC",
          );

        setIsCompanyWiseMeetingDataSync(
          enableMeetingwiseDataSync && enableMeetingwiseDataSync.length > 0
            ? enableMeetingwiseDataSync[0].isEnable === true
              ? true
              : false
            : false,
        );

        const enableLongestPath =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "SHOW_LONGEST_PATH",
          );

        dispatch({
          type: "LONGEST_PATH",
          payload:
            enableLongestPath && enableLongestPath.length > 0
              ? enableLongestPath[0].isEnable === true
              : false,
        });

        const enableVendor =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE",
          );

        dispatch({
          type: "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE",
          payload:
            enableVendor && enableVendor.length > 0
              ? enableVendor[0].isEnable === true
              : false,
        });

        const enableStartOdAutomaticallyAfterMidnight =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT",
          );

        dispatch({
          type: "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT",
          payload:
            enableStartOdAutomaticallyAfterMidnight &&
            enableStartOdAutomaticallyAfterMidnight.length > 0
              ? enableStartOdAutomaticallyAfterMidnight[0].isEnable === true
              : false,
        });

        const enableDisableDefaultMeetingWithoutInfo =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName ===
              "DISABLE_DEFAULT_MEETING_WITHOUT_INFO",
          );

        dispatch({
          type: "DISABLE_DEFAULT_MEETING_WITHOUT_INFO",
          payload:
            enableDisableDefaultMeetingWithoutInfo &&
            enableDisableDefaultMeetingWithoutInfo.length > 0
              ? enableDisableDefaultMeetingWithoutInfo[0].isEnable === true
              : false,
        });


        const enableCompanyWiseUserGoogleRouteMode =
          response.data &&
          response.data.find(
            (val) =>
              val.hrmsConfigurationName ===
              "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE",
          );

        dispatch({
          type: "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE",
          payload: Boolean(enableCompanyWiseUserGoogleRouteMode?.isEnable),
        });

        setIsBackgroundServiceEnable(
          backgroundServiceEnableToSet &&
            backgroundServiceEnableToSet.length > 0
            ? backgroundServiceEnableToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setIsCompanyWiseApiDataSync(
          syncCompanyApiData && syncCompanyApiData.length > 0
            ? syncCompanyApiData[0].isEnable === true
              ? true
              : false
            : false,
        );
        setIsMeetingSubmitWithoutLocationRestriction(
          meetingSubmissionWithoutLocationRestriction &&
            meetingSubmissionWithoutLocationRestriction.length > 0
            ? meetingSubmissionWithoutLocationRestriction[0].isEnable === true
              ? true
              : false
            : false,
        );
        setIsAddClientWeb(
          isAddClientWebToSet && isAddClientWebToSet.length > 0
            ? isAddClientWebToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsReimbursementAccess(
          isReimbursementAccessToSet && isReimbursementAccessToSet.length > 0
            ? isReimbursementAccessToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsMultipleFormForClient(
          isMultipleFormForClientToSet &&
            isMultipleFormForClientToSet.length > 0
            ? isMultipleFormForClientToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsShiftCompletionNotification(
          isShiftCompletionNotificationToSet &&
            isShiftCompletionNotificationToSet.length > 0
            ? isShiftCompletionNotificationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsGpsLossNotification(
          isGpsLossNotificationToSet && isGpsLossNotificationToSet.length > 0
            ? isGpsLossNotificationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsMeetingSubmissionPushNotification(
          isMeetingSubmissionPushNotificationToSet &&
            isMeetingSubmissionPushNotificationToSet.length > 0
            ? isMeetingSubmissionPushNotificationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsRemarkEnableForDefaultMeeting(
          isRemarkEnableForDefaultMeetingToSet &&
            isRemarkEnableForDefaultMeetingToSet.length > 0
            ? isRemarkEnableForDefaultMeetingToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsExpenseBulkApprove(
          isExpenseBulkApproveToSet && isExpenseBulkApproveToSet.length > 0
            ? isExpenseBulkApproveToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsDefaultMeeting(
          isDefaultMeetingToSet && isDefaultMeetingToSet.length > 0
            ? isDefaultMeetingToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsBankDetails(
          isBankDetailsToSet && isBankDetailsToSet.length > 0
            ? isBankDetailsToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsWhatsApp(
          whatsAppToSet && whatsAppToSet.length > 0
            ? whatsAppToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setGstAndPan(
          gstAndPanToSet && gstAndPanToSet.length > 0
            ? gstAndPanToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setAllowOrderWithDecimal(
          allowOrderWithDecimalToSet && allowOrderWithDecimalToSet.length > 0
            ? allowOrderWithDecimalToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableUnitConversion(
          unitConversionEnable && unitConversionEnable.length > 0
            ? unitConversionEnable[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowLocalityOnOrder(
          localityShowOnOrder && localityShowOnOrder.length > 0
            ? localityShowOnOrder[0].isEnable === true
              ? true
              : false
            : false,
        );

        setDistanceCalculate(
          distance && distance.length > 0
            ? distance[0].isEnable === true
              ? true
              : false
            : false,
        );
        setDistanceEndTime(
          distance && distance.length > 0 ? distance[0].configurationValue : "",
        );

        setLocationActive(
          location && location.length > 0
            ? location[0].isEnable === true
              ? true
              : false
            : false,
        );

        setLocationActiveActual(
          location && location.length > 0
            ? location[0].isEnable === true
              ? true
              : false
            : false,
        );

        setLocationEndTime(
          location && location.length > 0 ? location[0].configurationValue : "",
        );

        setMeettingStart(
          mettingstart && mettingstart.length > 0
            ? mettingstart[0].isEnable === true
              ? true
              : false
            : false,
        );
        setAttendanceStart(
          Schedule && Schedule.length > 0
            ? Schedule[0].isEnable === true
              ? true
              : false
            : false,
        );
        setAllclinetView(
          Allclient && Allclient.length > 0
            ? Allclient[0].isEnable === true
              ? true
              : false
            : false,
        );
        setSingleMetting(
          singleMetting && singleMetting.length > 0
            ? singleMetting[0].isEnable
            : false,
        );
        setBackWordStatus(
          backWord && backWord.length > 0 ? backWord[0].isEnable : false,
        );
        setFinalStatus(
          finalchange && finalchange.length > 0
            ? finalchange[0].isEnable
            : false,
        );
        setFixedOrderStataus(
          oneLevelChange && oneLevelChange.length > 0
            ? oneLevelChange[0].isEnable
            : false,
        );
        setIsMultiLevelApprover(
          multiLevelApproverToSet && multiLevelApproverToSet.length > 0
            ? multiLevelApproverToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableUndertakingForm(
          enableUndertakingFormToSet && enableUndertakingFormToSet.length > 0
            ? enableUndertakingFormToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowGPSLoationStatus(
          showGPSLocationStatusToSet && showGPSLocationStatusToSet.length > 0
            ? showGPSLocationStatusToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowUserLoginPermissionConfig(
          userLoginPermissionConfigurationToSet &&
            userLoginPermissionConfigurationToSet.length > 0
            ? userLoginPermissionConfigurationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowAudioOption(
          showAudioOptionToSet && showAudioOptionToSet.length > 0
            ? showAudioOptionToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowActualPath(
          showActualPathToSet && showActualPathToSet.length > 0
            ? showActualPathToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowLiveTracking(
          showLiveTrackingToSet && showLiveTrackingToSet.length > 0
            ? showLiveTrackingToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableLiveTrackingOnOdWithoutMeeting(
          enableLiveTrackingOnOdWithoutMeetingToShow &&
            enableLiveTrackingOnOdWithoutMeetingToShow.length > 0
            ? enableLiveTrackingOnOdWithoutMeetingToShow[0].isEnable === true
              ? true
              : false
            : false,
        );

        setShowRouteAndResponse(
          showRouteAndResponseToShow && showRouteAndResponseToShow.length > 0
            ? showRouteAndResponseToShow[0].isEnable === true
              ? true
              : false
            : false,
        );

        setSingleDeviceLoginPermission(
          singleDeviceLoginPermissionToSet &&
            singleDeviceLoginPermissionToSet.length > 0
            ? singleDeviceLoginPermissionToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableAdsConfig(
          enableAdsConfigToSet && enableAdsConfigToSet.length > 0
            ? enableAdsConfigToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setIsImageUploadEnableInDefaultMeeting(
          isImageUploadEnableInDefaultMeetingToSet &&
            isImageUploadEnableInDefaultMeetingToSet.length > 0
            ? isImageUploadEnableInDefaultMeetingToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableMultipleTrackingDataForSingleDay(
          enableMultipleTrackingDataForSingleDayToSet &&
            enableMultipleTrackingDataForSingleDayToSet.length > 0
            ? enableMultipleTrackingDataForSingleDayToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setOdometerReadingRequiredOnOd(
          odometerReadingRequiredOnOdToSet &&
            odometerReadingRequiredOnOdToSet.length > 0
            ? odometerReadingRequiredOnOdToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableSiteConfiguration(
          enableSiteConfigurationToSet &&
            enableSiteConfigurationToSet.length > 0
            ? enableSiteConfigurationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        if (
          (companyId && companyId?.id !== companyIdByBtn) ||
          (companyId && companyId?.id === companyIdByBtn && !siteId)
        ) {
          setOriginalEnableSiteConfiguration(
            enableSiteConfigurationToSet &&
              enableSiteConfigurationToSet.length > 0
              ? enableSiteConfigurationToSet[0].isEnable === true
                ? true
                : false
              : false,
          );
        }

        setEnableScheduleMeetingBulkApprove(
          enableScheduleMeetingBulkApproveToSet &&
            enableScheduleMeetingBulkApproveToSet.length > 0
            ? enableScheduleMeetingBulkApproveToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableHrmsDepartment(
          enableHrmsDepartmentToShow && enableHrmsDepartmentToShow.length > 0
            ? enableHrmsDepartmentToShow[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableSubDepartment(
          enableSubDepartmentToSet && enableSubDepartmentToSet.length > 0
            ? enableSubDepartmentToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableOdRestrictionsOnWeekOffs(
          enableOdRestrictionsOnWeekOffsToSet &&
            enableOdRestrictionsOnWeekOffsToSet.length > 0
            ? enableOdRestrictionsOnWeekOffsToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableOdRestoration(
          enableOdRestorationToSet && enableOdRestorationToSet.length > 0
            ? enableOdRestorationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableCompanyPermissionConfiguration(
          enableCompanyPermissionConfigurationToSet &&
            enableCompanyPermissionConfigurationToSet.length > 0
            ? enableCompanyPermissionConfigurationToSet[0].isEnable === true
              ? true
              : false
            : false,
        );

        setEnableGeofenceManagement(
          enableGeofenceManagementToSet &&
            enableGeofenceManagementToSet.length > 0
            ? enableGeofenceManagementToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setEnableMeetingAutoSubmitAfterCertainDistance(
          enableMeetingAutoSubmitAfterCertainDistanceToSet &&
            enableMeetingAutoSubmitAfterCertainDistanceToSet.length > 0
            ? enableMeetingAutoSubmitAfterCertainDistanceToSet[0].isEnable ===
              true
              ? true
              : false
            : false,
        );

        if (response.responseCode === 404) {
          alert("No record found ");
          setMeettingStart(false);
          setAttendanceStart(false);
          setAllclinetView(false);
          setSingleMetting(false);
          setBackWordStatus(false);
          setFinalStatus(false);
          setFixedOrderStataus(false);
          setDistanceCalculate(false);
          setCompanyConfigurationData([]);
        }
        if (response.responseCode === 500) {
          alert("No record found ");
          setMeettingStart(false);
          setAttendanceStart(false);
          setAllclinetView(false);
          setSingleMetting(false);
          setBackWordStatus(false);
          setFinalStatus(false);
          setFixedOrderStataus(false);
          setLocationActive(false);
          setLocationActiveActual(false);
          setCompanyConfigurationData([]);
        }
      } else {
        setMeettingStart(false);
        setAttendanceStart(false);
        setAllclinetView(false);
        setSingleMetting(false);
        setBackWordStatus(false);
        setFinalStatus(false);
        setFixedOrderStataus(false);
        setFixedOrderStataus(false);
        setLocationActive(false);
        setLocationActiveActual(false);
        setCompanyConfigurationData([]);
        setOriginalEnableSiteConfiguration(false);
      }
    });
  };

  const fetchUsersListBySelectedCompany = async () => {
    const res = await PermissionMasterAction.getCompanyWiseUser({
      // companyId: selectedCompany.id,
      companyId: companyId.id,
      siteId: siteId?.id || null,
    });
    if (res !== null && res.data[0]) {
      setUserListByCompany(res.data[0].userDtoList || []);
    } else {
      setUserListByCompany([]);
    }
  };

  const fetchUsersListBySelectedCompanyForAttendance = async () => {
    const hrmsToken = JSON.parse(localStorage.getItem("data")).hrmsToken;

    const res = await companyWiseEmp.getHrmsUserListByCompanyId({
      // companyId: selectedCompany.id,
      companyId: companyId.id,
      hrmsToken,
      siteId: siteId?.id || null,
    });
    if (res !== null) {
      if (Boolean(res?.data?.length)) {
        setUserListByCompanyForAttendance(res?.data || []);
      }

      if (res.responseCode === 404) {
        alert("No record found Status List!!");
        setUserListByCompanyForAttendance([]);
      }
    }
  };

  const fetchGetWhatsappConfiguration = async () => {
    const res = await companyWiseEmp?.getWhatsappConfiguration({
      companyId: companyId?.id,
    });

    if (res !== null) {
      setWhatsappConfigurationFormData((prevData) => ({
        ...prevData,
        maxMonthLimit: res?.maxMonthLimit || 0,
        maxMonthLimitReadOnly: res?.maxMonthLimit || 0,
        currentMonthLimit: res?.currentMonthLimit || 0,
        lastSentOn: res?.lastSentOn || "",
        fromDate: "",
        toDate: "",
        counts: res?.counts || 0,
      }));
    } else {
      setWhatsappConfigurationFormData((prevData) => ({
        ...prevData,
        maxMonthLimit: 0,
        maxMonthLimitReadOnly: 0,
        currentMonthLimit: 0,
        lastSentOn: "",
        fromDate: "",
        toDate: "",
        counts: 0,
      }));
    }
  };

  const fetchSaveWhatsappMaxMessageLimit = async () => {
    if (
      !Boolean(whatsappConfigurationFormData?.maxMonthLimit) ||
      !Boolean(whatsappConfigurationFormData?.maxMonthLimit > 0)
    ) {
      alert("Give A valid Max Limit!");
      setWhatsappConfigurationFormData((prevData) => ({
        ...prevData,
        maxMonthLimit: prevData.maxMonthLimitReadOnly,
      }));
      return;
    }

    const payload = {
      companyId: companyId?.id,
      maxMonthLimit: whatsappConfigurationFormData?.maxMonthLimit,
    };

    const res = await companyWiseEmp?.saveWhatsappMaxMessageLimit(payload);

    console.log("save whatsapp max limit res: ", res);
    if (res && res?.status === 200) {
      alert(res?.data);
      fetchGetWhatsappConfiguration();
    } else {
      alert(res?.response?.data || res?.message || "");
      // fetchGetWhatsappConfiguration();
    }
  };

  const fetchGetCompanywiseWhatsappMessageCount = async () => {
    if (
      Boolean(
        !Boolean(whatsappConfigurationFormData?.toDate) ||
        !Boolean(whatsappConfigurationFormData?.fromDate),
      )
    ) {
      alert("Please Select From Date & To Date!");
      return;
    }
    const payload = {
      companyId: companyId?.id,
      fromDate: whatsappConfigurationFormData?.fromDate,
      toDate: whatsappConfigurationFormData?.toDate,
    };

    const res =
      await companyWiseEmp?.getCompanywiseWhatsappMessageCount(payload);

    console.log("fetchGetCompanywiseWhatsappMessageCount res: ", res);

    if (res !== null) {
      setWhatsappConfigurationFormData((prevData) => ({
        ...prevData,
        counts: res || 0,
      }));
    } else {
      setWhatsappConfigurationFormData((prevData) => ({
        ...prevData,
        counts: 0,
      }));
    }
  };

  const fetchDitanceConfiguration = (type) => {
    var regex = /^[-+]?[0-9]+\.[0-9]+$/;
    var isValidated = regex.test(locationEndTime);
    if (isValidated) {
      alert("Please Enter Digits Only");
      //document.getElementById("para").innerHTML = "Given number is a decimal number";
      return false;
    }
    const distanceId =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "User Location Tracking Logic",
      );
    const locationId =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "Location Tracking Interval",
      );

    const distance = [
      {
        ids: distanceId && distanceId.length > 0 ? [distanceId[0].id] : null,
        hrmsConfigurationName: "User Location Tracking Logic",
        companyId: companyId ? companyId.id : null,
        isEnable: distanceCalculate,
        configurationValue: distanceEndTime,
      },
    ];

    const location = [
      {
        ids: locationId && locationId.length > 0 ? [locationId[0].id] : null,
        hrmsConfigurationName: "Location Tracking Interval",
        companyId: companyId ? companyId.id : null,
        isEnable: locationActive,
        locationTrackingInterval: locationEndTime,
      },
    ];

    companyWiseEmp
      .fetchCompnatbyData(type === "distance" ? distance : location)
      .then((response) => {
        if (response !== null) {
          fetchClientBaseEmp();
          alert("Updated Successfully!!");
        } else {
        }
      });
  };

  const fetchCompanyConfiguration = () => {
    const mettingstart =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "Meeting start and End option for duration",
      );
    const Schedule =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "Schedule meeting follow up with date or without datetime",
      );
    const Allclient =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "All client or own client view",
      );
    const singleMettingId =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "Single meeting distance",
      );

    const backWord =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "is One step back allowed",
      );
    const finalchange =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "is Final state Editable",
      );
    const oneLevelChange =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "Fixed order of status",
      );

    const localityShowOnOrder =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "LOCALITY_SHOW_ON_ORDER_CREATE",
      );

    const unitConversionEnable =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "UNIT_CONVERSION_VISIBILITY",
      );

    const allowOrderWithDecimalToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ALLOW_ORDER_WITH_DECIMALS",
      );

    const gstAndPanToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "GSTIN_AND_PAN_MANDETORY",
      );

    const isWhatsAppToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "WHATSAPP_ENABLE",
      );

    const isBankDetailsToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ACCOUNT_DETAILS_SHOW_ON_INVOICE_PAGE",
      );

    const isDefaultMeetingToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "DEFAULT_MEETING_CONFIGURATION",
      );

    const isMultiLevelApproverToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "COMPANY_WISE_MULTILEVEL_APPROVER",
      );

    const isExpenseBulkApproveToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "EXPENSE_BULK_APPROVE",
      );

    const enableUndertakingFormToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_UNDERTAKING_FORM",
      );

    const showGPSLocationStatusToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "GPS_LOCATION_STATUS",
      );

    const isRemarkEnableForDefaultMeetingToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "IS_REMARK_ENABLE_IN_DEFAULT_MEETING",
      );

    const isMeetingSubmissionPushNotificationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "MEETING_SUBMISSION_PUSH_NOTIFICATION",
      );

    const isGpsLossNotificationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_GPS_LOSS_NOTIFICATION",
      );

    const isShiftCompletionNotificationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ENABLE_SHIFT_COMPLETION_NOTIFICATION",
      );

    const isUserLoginPermissionConfigurationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "SFA_LOGIN_PERMISSION_CONFIG",
      );

    const isShowAudioOptionToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "AUDIO_CONFIGURATION_ENABLED",
      );

    const isMultipleFormForClientToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ENABLE_MULTIPLE_FORM_FOR_CLIENT",
      );

    const isReimbursementAccessToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ENABLE_REIMBERSUMENT_CONFIGURATION",
      );

    const isAddClientWebToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_ADD_CLIENT_ON_WEB",
      );

    const isShowActualPathToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "SHOW_ACTUAL_PATH",
      );

    const isShowLiveTrackingToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "LIVE_TRACKING",
      );

    const isEnableLiveTrackingOnOdWithoutMeetingToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "OD_LIVE_TRACKING_NO_MEETING",
      );

    const isShowRouteAndResponseToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "MEETING_WISE_ROUTE_CREATION",
      );
    const isEnableBackendService =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "BACKGROUND_SERVICE_ENABLED",
      );
    console.log("isEnableBackendService", isEnableBackendService);

    const isEnableCompanywiseAPIDataSync =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "THIRD_PARTY_API_SYNC_FOR_CLIENT",
      );

    const isAllowMeetingSubmitWithoutLocationRestriction =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "MEETING_SUBMIT_WITHOUT_LOCATION_RESTRICTION",
      );

    const isSingleDeviceLoginPermissionToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "SINGLE_DEVICE_LOGIN_PERMISSION",
      );

    const isEnableAdsConfigToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_ADS_CONFIGURATION",
      );

    const isImageUploadEnableInDefaultMeetingToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "IS_IMAGE_UPLOAD_ENABLE_IN_DEFAULT_MEETING",
      );

    const isEnableMultipleTrackingDataForSingleDayToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "ENABLE_MULTIPLE_TRACKING_DATA_FOR_SINGLE_DAY",
      );

    const isOdometerReadingRequiredOnOdToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ODOMETER_READING_REQUIRED_ON_OD",
      );

    const isEnableSiteConfigurationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_SITE_CONFIG",
      );
    const isEnableScheduleMeetingBulkApproveToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "SCHEDULE_MEETING_BULK_IMPORT",
      );
    const isEnableHrmsDepartmentToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_HRMS_DEPARTMENT",
      );
    const isEnableSubDepartmentToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_SUB_DEPARTMENT",
      );
    const isEnableOdRestrictionsOnWeekOffsToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "OD_RESTRICTIONS_ON_WEEKOFFS",
      );

    const isEnableOdRestoration =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ENABLE_OD_RESTORATION_PERMISSION",
      );

    const isEnableGeofenceManagementToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "ENABLE_GEOFENCE_MANAGEMENT",
      );

    const isEnableCompanyPermissionConfigurationToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "COMPANY_PERMISSION_CONFIGURATION",
      );

    const isEnableMeetingAutoSubmitAfterCertainDistanceToSend =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "MEETING_AUTO_SUBMIT_AFTER_CERTAIN_DISTANCE",
      );

    const isEnableCompanyWiseMeetingDataSync =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "ENABLE_COMPANY_WISE_MEETING_DATA_SYNC",
      );

    const isEnableLongestPath =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) => val.hrmsConfigurationName === "SHOW_LONGEST_PATH",
      );

    const isEnableVendor =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE",
      );

    const isEnableStartOdAutomaticallyAfterMidnight =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT",
      );

    const isEnableCompanyWiseUserGoogleRouteMode =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName ===
          "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE",
      );

    const isDisableDefaultMeetingWithoutInfo =
      CompanyConfigurationData &&
      CompanyConfigurationData.filter(
        (val) =>
          val.hrmsConfigurationName === "DISABLE_DEFAULT_MEETING_WITHOUT_INFO",
      );

    const data = [
      {
        ids:
          isDisableDefaultMeetingWithoutInfo && isDisableDefaultMeetingWithoutInfo.length > 0 && isDisableDefaultMeetingWithoutInfo[0].id
            ? [isDisableDefaultMeetingWithoutInfo[0].id]
            : null,
        hrmsConfigurationName: "DISABLE_DEFAULT_MEETING_WITHOUT_INFO",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: state?.isDisableDefaultMeetingWithoutInfo,
      },
      {
        ids:
          isEnableStartOdAutomaticallyAfterMidnight && isEnableStartOdAutomaticallyAfterMidnight.length > 0 && isEnableStartOdAutomaticallyAfterMidnight[0].id
            ? [isEnableStartOdAutomaticallyAfterMidnight[0].id]
            : null,
        hrmsConfigurationName: "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: state?.isStartOdAutomaticallyAfterMidnight,
      },
      {
        ids:
          isEnableCompanyWiseUserGoogleRouteMode && isEnableCompanyWiseUserGoogleRouteMode.length > 0 && isEnableCompanyWiseUserGoogleRouteMode[0].id
            ? [isEnableCompanyWiseUserGoogleRouteMode[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: state?.isEnableCompanyWiseUserGoogleRouteMode,
      },
      {
        ids:
          isEnableVendor && isEnableVendor.length > 0 && isEnableVendor[0].id
            ? [isEnableVendor[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: state?.isEnableDefaultMeetingWithinGeofence,
      },
      {
        ids:
          isEnableLongestPath &&
          isEnableLongestPath.length > 0 &&
          isEnableLongestPath[0].id
            ? [isEnableLongestPath[0].id]
            : null,
        hrmsConfigurationName: "SHOW_LONGEST_PATH",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: state?.isShowLongestPath,
      },
      {
        ids:
          isEnableCompanyWiseMeetingDataSync &&
          isEnableCompanyWiseMeetingDataSync.length > 0 &&
          isEnableCompanyWiseMeetingDataSync[0].id
            ? [isEnableCompanyWiseMeetingDataSync[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_COMPANY_WISE_MEETING_DATA_SYNC",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isCompanyWiseMeetingDataSync
          ? isCompanyWiseMeetingDataSync
          : false,
      },
      {
        ids:
          mettingstart && mettingstart.length > 0 && mettingstart[0].id
            ? [mettingstart[0].id]
            : null,
        hrmsConfigurationName: "Meeting start and End option for duration",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: meetingStart ? meetingStart : false,
      },
      {
        ids:
          Schedule && Schedule.length > 0 && Schedule[0].id
            ? [Schedule[0].id]
            : null,
        hrmsConfigurationName:
          "Schedule meeting follow up with date or without datetime",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: AttendanceStart ? AttendanceStart : false,
      },
      {
        ids:
          Allclient && Allclient.length > 0 && Allclient[0].id
            ? [Allclient[0].id]
            : null,
        hrmsConfigurationName: "All client or own client view",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: AllclinetView ? AllclinetView : false,
      },
      {
        ids:
          singleMettingId && singleMettingId.length > 0 && singleMettingId[0].id
            ? [singleMettingId[0].id]
            : null,
        hrmsConfigurationName: "Single meeting distance",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: singleMetting ? singleMetting : false,
      },

      {
        ids:
          backWord && backWord.length > 0 && backWord[0].id
            ? [backWord[0].id]
            : null,
        hrmsConfigurationName: "is One step back allowed",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: BackWordStatus ? BackWordStatus : false,
      },
      {
        ids:
          finalchange && finalchange.length > 0 && finalchange[0].id
            ? [finalchange[0].id]
            : null,
        hrmsConfigurationName: "is Final state Editable",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: FinalStatus ? FinalStatus : false,
      },
      {
        ids:
          oneLevelChange && oneLevelChange.length > 0 && oneLevelChange[0].id
            ? [oneLevelChange[0].id]
            : null,
        hrmsConfigurationName: "Fixed order of status",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: FixedOrderStataus ? FixedOrderStataus : false,
      },
      {
        ids:
          localityShowOnOrder &&
          localityShowOnOrder.length > 0 &&
          localityShowOnOrder[0].id
            ? [localityShowOnOrder[0].id]
            : null,
        hrmsConfigurationName: "LOCALITY_SHOW_ON_ORDER_CREATE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showLocalityOnOrder ? showLocalityOnOrder : false,
      },
      {
        ids:
          unitConversionEnable &&
          unitConversionEnable.length > 0 &&
          unitConversionEnable[0].id
            ? [unitConversionEnable[0].id]
            : null,
        hrmsConfigurationName: "UNIT_CONVERSION_VISIBILITY",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableUnitConversion ? enableUnitConversion : false,
      },
      {
        ids:
          allowOrderWithDecimalToSend &&
          allowOrderWithDecimalToSend.length > 0 &&
          allowOrderWithDecimalToSend[0].id
            ? [allowOrderWithDecimalToSend[0].id]
            : null,
        hrmsConfigurationName: "ALLOW_ORDER_WITH_DECIMALS",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: allowOrderWithDecimal ? allowOrderWithDecimal : false,
      },
      {
        ids:
          gstAndPanToSend && gstAndPanToSend.length > 0 && gstAndPanToSend[0].id
            ? [gstAndPanToSend[0].id]
            : null,
        hrmsConfigurationName: "GSTIN_AND_PAN_MANDETORY",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: gstAndPan ? gstAndPan : false,
      },
      {
        ids:
          isWhatsAppToSend &&
          isWhatsAppToSend.length > 0 &&
          isWhatsAppToSend[0].id
            ? [isWhatsAppToSend[0].id]
            : null,
        hrmsConfigurationName: "WHATSAPP_ENABLE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isWhatsApp ? isWhatsApp : false,
      },
      {
        ids:
          isBankDetailsToSend &&
          isBankDetailsToSend.length > 0 &&
          isBankDetailsToSend[0].id
            ? [isBankDetailsToSend[0].id]
            : null,
        hrmsConfigurationName: "ACCOUNT_DETAILS_SHOW_ON_INVOICE_PAGE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isBankDetails ? isBankDetails : false,
      },
      {
        ids:
          isDefaultMeetingToSend &&
          isDefaultMeetingToSend.length > 0 &&
          isDefaultMeetingToSend[0].id
            ? [isDefaultMeetingToSend[0].id]
            : null,
        hrmsConfigurationName: "DEFAULT_MEETING_CONFIGURATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isDefaultMeeting ? isDefaultMeeting : false,
      },
      {
        ids:
          isMultiLevelApproverToSend &&
          isMultiLevelApproverToSend.length > 0 &&
          isMultiLevelApproverToSend[0].id
            ? [isMultiLevelApproverToSend[0].id]
            : null,
        hrmsConfigurationName: "COMPANY_WISE_MULTILEVEL_APPROVER",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isMultiLevelApprover ? isMultiLevelApprover : false,
      },
      {
        ids:
          isExpenseBulkApproveToSend &&
          isExpenseBulkApproveToSend.length > 0 &&
          isExpenseBulkApproveToSend[0].id
            ? [isExpenseBulkApproveToSend[0].id]
            : null,
        hrmsConfigurationName: "EXPENSE_BULK_APPROVE",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isExpenseBulkApprove ? isExpenseBulkApprove : false,
      },
      {
        ids:
          enableUndertakingFormToSend &&
          enableUndertakingFormToSend.length > 0 &&
          enableUndertakingFormToSend[0].id
            ? [enableUndertakingFormToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_UNDERTAKING_FORM",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableUndertakingForm ? enableUndertakingForm : false,
      },
      {
        ids:
          showGPSLocationStatusToSend &&
          showGPSLocationStatusToSend.length > 0 &&
          showGPSLocationStatusToSend[0].id
            ? [showGPSLocationStatusToSend[0].id]
            : null,
        hrmsConfigurationName: "GPS_LOCATION_STATUS",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showGPSLoationStatus ? showGPSLoationStatus : false,
      },
      {
        ids:
          isRemarkEnableForDefaultMeetingToSend &&
          isRemarkEnableForDefaultMeetingToSend.length > 0 &&
          isRemarkEnableForDefaultMeetingToSend[0].id
            ? [isRemarkEnableForDefaultMeetingToSend[0].id]
            : null,
        hrmsConfigurationName: "IS_REMARK_ENABLE_IN_DEFAULT_MEETING",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isRemarkEnableForDefaultMeeting
          ? isRemarkEnableForDefaultMeeting
          : false,
      },
      {
        ids:
          isMeetingSubmissionPushNotificationToSend &&
          isMeetingSubmissionPushNotificationToSend.length > 0 &&
          isMeetingSubmissionPushNotificationToSend[0].id
            ? [isMeetingSubmissionPushNotificationToSend[0].id]
            : null,
        hrmsConfigurationName: "MEETING_SUBMISSION_PUSH_NOTIFICATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isMeetingSubmissionPushNotification
          ? isMeetingSubmissionPushNotification
          : false,
      },
      {
        ids:
          isGpsLossNotificationToSend &&
          isGpsLossNotificationToSend.length > 0 &&
          isGpsLossNotificationToSend[0].id
            ? [isGpsLossNotificationToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_GPS_LOSS_NOTIFICATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isGpsLossNotification ? isGpsLossNotification : false,
      },
      {
        ids:
          isShiftCompletionNotificationToSend &&
          isShiftCompletionNotificationToSend.length > 0 &&
          isShiftCompletionNotificationToSend[0].id
            ? [isShiftCompletionNotificationToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_SHIFT_COMPLETION_NOTIFICATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isShiftCompletionNotification
          ? isShiftCompletionNotification
          : false,
      },
      {
        ids:
          isUserLoginPermissionConfigurationToSend &&
          isUserLoginPermissionConfigurationToSend.length > 0 &&
          isUserLoginPermissionConfigurationToSend[0].id
            ? [isUserLoginPermissionConfigurationToSend[0].id]
            : null,
        hrmsConfigurationName: "SFA_LOGIN_PERMISSION_CONFIG",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showUserLoginPermissionConfig
          ? showUserLoginPermissionConfig
          : false,
      },
      {
        ids:
          isShowAudioOptionToSend &&
          isShowAudioOptionToSend.length > 0 &&
          isShowAudioOptionToSend[0].id
            ? [isShowAudioOptionToSend[0].id]
            : null,
        hrmsConfigurationName: "AUDIO_CONFIGURATION_ENABLED",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showAudioOption ? showAudioOption : false,
      },
      {
        ids:
          isMultipleFormForClientToSend &&
          isMultipleFormForClientToSend.length > 0 &&
          isMultipleFormForClientToSend[0].id
            ? [isMultipleFormForClientToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_MULTIPLE_FORM_FOR_CLIENT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isMultipleFormForClient ? isMultipleFormForClient : false,
      },
      {
        ids:
          isReimbursementAccessToSend &&
          isReimbursementAccessToSend.length > 0 &&
          isReimbursementAccessToSend[0].id
            ? [isReimbursementAccessToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_REIMBERSUMENT_CONFIGURATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isReimbursementAccess ? isReimbursementAccess : false,
      },

      {
        ids:
          isAddClientWebToSend &&
          isAddClientWebToSend.length > 0 &&
          isAddClientWebToSend[0].id
            ? [isAddClientWebToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_ADD_CLIENT_ON_WEB",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isAddClientWeb ? isAddClientWeb : false,
      },
      {
        ids:
          isShowActualPathToSend &&
          isShowActualPathToSend.length > 0 &&
          isShowActualPathToSend[0].id
            ? [isShowActualPathToSend[0].id]
            : null,
        hrmsConfigurationName: "SHOW_ACTUAL_PATH",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showActualPath ? showActualPath : false,
      },

      {
        ids:
          isShowLiveTrackingToSend &&
          isShowLiveTrackingToSend.length > 0 &&
          isShowLiveTrackingToSend[0].id
            ? [isShowLiveTrackingToSend[0].id]
            : null,
        hrmsConfigurationName: "LIVE_TRACKING",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showLiveTracking ? showLiveTracking : false,
      },
      {
        ids:
          isEnableLiveTrackingOnOdWithoutMeetingToSend &&
          isEnableLiveTrackingOnOdWithoutMeetingToSend.length > 0 &&
          isEnableLiveTrackingOnOdWithoutMeetingToSend[0].id
            ? [isEnableLiveTrackingOnOdWithoutMeetingToSend[0].id]
            : null,
        hrmsConfigurationName: "OD_LIVE_TRACKING_NO_MEETING",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableLiveTrackingOnOdWithoutMeeting
          ? enableLiveTrackingOnOdWithoutMeeting
          : false,
      },

      {
        ids:
          isShowRouteAndResponseToSend &&
          isShowRouteAndResponseToSend.length > 0 &&
          isShowRouteAndResponseToSend[0].id
            ? [isShowRouteAndResponseToSend[0].id]
            : null,
        hrmsConfigurationName: "MEETING_WISE_ROUTE_CREATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: showRouteAndResponse ? showRouteAndResponse : false,
      },
      {
        ids:
          isEnableBackendService &&
          isEnableBackendService.length > 0 &&
          isEnableBackendService[0].id
            ? [isEnableBackendService[0].id]
            : null,
        hrmsConfigurationName: "BACKGROUND_SERVICE_ENABLED",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isBackgroundServiceEnable ? isBackgroundServiceEnable : false,
      },
      {
        ids:
          isEnableCompanywiseAPIDataSync &&
          isEnableCompanywiseAPIDataSync.length > 0 &&
          isEnableCompanywiseAPIDataSync[0].id
            ? [isEnableCompanywiseAPIDataSync[0].id]
            : null,
        hrmsConfigurationName: "THIRD_PARTY_API_SYNC_FOR_CLIENT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isCompanyWiseApiDataSync ? isCompanyWiseApiDataSync : false,
      },
      {
        ids:
          isSingleDeviceLoginPermissionToSend &&
          isSingleDeviceLoginPermissionToSend.length > 0 &&
          isSingleDeviceLoginPermissionToSend[0].id
            ? [isSingleDeviceLoginPermissionToSend[0].id]
            : null,
        hrmsConfigurationName: "SINGLE_DEVICE_LOGIN_PERMISSION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: singleDeviceLoginPermission
          ? singleDeviceLoginPermission
          : false,
      },
      {
        ids:
          isAllowMeetingSubmitWithoutLocationRestriction &&
          isAllowMeetingSubmitWithoutLocationRestriction.length > 0 &&
          isAllowMeetingSubmitWithoutLocationRestriction[0].id
            ? [isAllowMeetingSubmitWithoutLocationRestriction[0].id]
            : null,
        hrmsConfigurationName: "MEETING_SUBMIT_WITHOUT_LOCATION_RESTRICTION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isMeetingSubmitWithoutLocationRestriction
          ? isMeetingSubmitWithoutLocationRestriction
          : false,
      },
      {
        ids:
          isEnableAdsConfigToSend &&
          isEnableAdsConfigToSend.length > 0 &&
          isEnableAdsConfigToSend[0].id
            ? [isEnableAdsConfigToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_ADS_CONFIGURATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableAdsConfig ? enableAdsConfig : false,
      },
      {
        ids:
          isImageUploadEnableInDefaultMeetingToSend &&
          isImageUploadEnableInDefaultMeetingToSend.length > 0 &&
          isImageUploadEnableInDefaultMeetingToSend[0].id
            ? [isImageUploadEnableInDefaultMeetingToSend[0].id]
            : null,
        hrmsConfigurationName: "IS_IMAGE_UPLOAD_ENABLE_IN_DEFAULT_MEETING",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: isImageUploadEnableInDefaultMeeting
          ? isImageUploadEnableInDefaultMeeting
          : false,
      },
      {
        ids:
          isEnableMultipleTrackingDataForSingleDayToSend &&
          isEnableMultipleTrackingDataForSingleDayToSend.length > 0 &&
          isEnableMultipleTrackingDataForSingleDayToSend[0].id
            ? [isEnableMultipleTrackingDataForSingleDayToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_MULTIPLE_TRACKING_DATA_FOR_SINGLE_DAY",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableMultipleTrackingDataForSingleDay
          ? enableMultipleTrackingDataForSingleDay
          : false,
      },
      {
        ids:
          isOdometerReadingRequiredOnOdToSend &&
          isOdometerReadingRequiredOnOdToSend.length > 0 &&
          isOdometerReadingRequiredOnOdToSend[0].id
            ? [isOdometerReadingRequiredOnOdToSend[0].id]
            : null,
        hrmsConfigurationName: "ODOMETER_READING_REQUIRED_ON_OD",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: odometerReadingRequiredOnOd
          ? odometerReadingRequiredOnOd
          : false,
      },
      {
        ids:
          isEnableSiteConfigurationToSend &&
          isEnableSiteConfigurationToSend.length > 0 &&
          isEnableSiteConfigurationToSend[0].id
            ? [isEnableSiteConfigurationToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_SITE_CONFIG",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableSiteConfiguration ? enableSiteConfiguration : false,
      },
      {
        ids:
          isEnableScheduleMeetingBulkApproveToSend &&
          isEnableScheduleMeetingBulkApproveToSend.length > 0 &&
          isEnableScheduleMeetingBulkApproveToSend[0].id
            ? [isEnableScheduleMeetingBulkApproveToSend[0].id]
            : null,
        hrmsConfigurationName: "SCHEDULE_MEETING_BULK_IMPORT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableScheduleMeetingBulkApprove
          ? enableScheduleMeetingBulkApprove
          : false,
      },
      {
        ids:
          isEnableHrmsDepartmentToSend &&
          isEnableHrmsDepartmentToSend.length > 0 &&
          isEnableHrmsDepartmentToSend[0].id
            ? [isEnableHrmsDepartmentToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_HRMS_DEPARTMENT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableHrmsDepartment ? enableHrmsDepartment : false,
      },
      {
        ids:
          isEnableSubDepartmentToSend &&
          isEnableSubDepartmentToSend.length > 0 &&
          isEnableSubDepartmentToSend[0].id
            ? [isEnableSubDepartmentToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_SUB_DEPARTMENT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableSubDepartment ? enableSubDepartment : false,
      },
      {
        ids:
          isEnableOdRestrictionsOnWeekOffsToSend &&
          isEnableOdRestrictionsOnWeekOffsToSend.length > 0 &&
          isEnableOdRestrictionsOnWeekOffsToSend[0].id
            ? [isEnableOdRestrictionsOnWeekOffsToSend[0].id]
            : null,
        hrmsConfigurationName: "OD_RESTRICTIONS_ON_WEEKOFFS",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableOdRestrictionsOnWeekOffs
          ? enableOdRestrictionsOnWeekOffs
          : false,
      },
      {
        ids:
          isEnableOdRestoration &&
          isEnableOdRestoration.length > 0 &&
          isEnableOdRestoration[0].id
            ? [isEnableOdRestoration[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_OD_RESTORATION_PERMISSION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableOdRestoration ? enableOdRestoration : false,
      },
      {
        ids:
          isEnableGeofenceManagementToSend &&
          isEnableGeofenceManagementToSend.length > 0 &&
          isEnableGeofenceManagementToSend[0].id
            ? [isEnableGeofenceManagementToSend[0].id]
            : null,
        hrmsConfigurationName: "ENABLE_GEOFENCE_MANAGEMENT",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableGeofenceManagement ? enableGeofenceManagement : false,
      },
      // {
      //   ids:
      //     isEnableMeetingAutoSubmitAfterCertainDistanceToSend &&
      //     isEnableMeetingAutoSubmitAfterCertainDistanceToSend.length > 0 &&
      //     isEnableMeetingAutoSubmitAfterCertainDistanceToSend[0].id
      //       ? [isEnableMeetingAutoSubmitAfterCertainDistanceToSend[0].id]
      //       : null,
      //   hrmsConfigurationName: "MEETING_AUTO_SUBMIT_AFTER_CERTAIN_DISTANCE",
      //   companyId: companyId ? companyId.id : null,
      //   siteId: siteIdByBtn ? siteIdByBtn?.id : null,
      //   isEnable: enableMeetingAutoSubmitAfterCertainDistance
      //     ? enableMeetingAutoSubmitAfterCertainDistance
      //     : false,
      // },
      {
        ids:
          isEnableCompanyPermissionConfigurationToSend &&
          isEnableCompanyPermissionConfigurationToSend.length > 0 &&
          isEnableCompanyPermissionConfigurationToSend[0].id
            ? [isEnableCompanyPermissionConfigurationToSend[0].id]
            : null,
        hrmsConfigurationName: "COMPANY_PERMISSION_CONFIGURATION",
        companyId: companyId ? companyId.id : null,
        siteId: siteIdByBtn ? siteIdByBtn?.id : null,
        isEnable: enableCompanyPermissionConfiguration
          ? enableCompanyPermissionConfiguration
          : false,
      },
    ];

    companyWiseEmp.fetchCompnatbyData(data).then((response) => {
      if (response !== null) {
        fetchClientBaseEmp();
        alert("Updated Successfully!!");
      } else {
      }
    });
  };

  const fetchUserCongiguration = () => {
    if (companyId === undefined || companyId === null) {
      alert("Please Select Company!");
      return false;
    }

    const data = [
      {
        hrmsConfigurationName: "Attendance on HRMS by OD(SFA) app",
        userIdList: usersId,
        companyId: companyId ? companyId.id : null,
        isAttendenceBothApp: AttendensSelectTypeId.type,
      },
    ];

    companyWiseEmp.fetchCompnatbyData(data).then((response) => {
      if (response !== null) {
        alert("Updated Successfully!!");
      } else {
      }
    });
  };
  const fetchGeofenceData = () => {
    if (geofanceLat === "") {
      alert("Please enter your geofance  latitude!");
      return false;
    } else if (companyId === undefined || companyId === null) {
      alert("Please Select Company!");
      return false;
    } else if (geofanceLong === "") {
      alert("Please enter your geofance longitude!");
      return false;
    } else if (geofanceDistance == "") {
      alert("Please enter your distance!");
      return false;
    } else if (geofanceDistanceEnd === "") {
      alert("Please enter your End Distance!");
      return false;
    } else if (geofanceLatEnd === "") {
      alert("Please enter your geofance End longitude!");
      return false;
    } else if (geofanceLongEnd === "") {
      alert("Please enter your geofance End longitude!");
      return false;
    }
    const data = [
      {
        hrmsConfigurationName: "Geofence based checkin/checkout",
        userIdList: GeofanceUserId ? GeofanceUserId : null,
        companyId: companyId ? companyId.id : null,
        latitude: geofanceLat ? Number(geofanceLat) : "",
        longitude: geofanceLong ? Number(geofanceLong) : "",
        distance: geofanceDistance ? Number(geofanceDistance) : "",
        endLatitude: geofanceLatEnd ? Number(geofanceLatEnd) : "",
        endLongitude: geofanceLongEnd ? Number(geofanceLongEnd) : "",
        endDistance: geofanceDistanceEnd ? Number(geofanceDistanceEnd) : "",
      },
    ];
    companyWiseEmp.fetchCompnatbyData(data).then((response) => {
      if (response !== null) {
        alert("update Successful!!");
      } else {
      }
    });
    setGeofancelat("");
    setGeofancelong("");
    setGeofanceDistance("");
    setGeofancelatEnd("");
    setGeofancelongEnd("");
    setGeofanceDistanceEnd("");
  };
  const getuserOnchange = (e) => {
    if (e !== null) {
      const alluserId =
        userList &&
        userList.map((val) => {
          return val.userId;
        });
      if (e[0]?.userId === "All") {
        setGeofanceUserId(alluserId);
      } else if (e[0]?.userId !== "All") {
        const multiselectId =
          e &&
          e.map((val) => {
            return val.userId;
          });

        setGeofanceUserId(multiselectId);
      }
    } else {
      setGeofanceUserId("");
    }
  };

  // const getuserOnchange1 = (e, type) => {
  //   if (e !== null) {
  //     const alluserId =
  //       userList &&
  //       userList.map((val) => {
  //         return val.userId;
  //       });
  //     if (e[0]?.userId === "All") {
  //       if (type === "StandLive") {
  //         setStandLiveUserId(alluserId);
  //       } else if (type === "Attendance") {
  //         setUsersId(alluserId);
  //       }
  //       // setUsersId(alluserId);
  //     } else if (e[0]?.userId !== "All") {
  //       const multiselectId =
  //         e &&
  //         e.map((val) => {
  //           return val.userId;
  //         });

  //       if (type === "StandLive") {
  //         setStandLiveUserId(multiselectId);
  //       } else if (type === "Attendance") {
  //         setUsersId(multiselectId);
  //       }
  //       // setUsersId(multiselectId);
  //     }
  //   } else {
  //     if (type === "StandLive") {
  //       setStandLiveUserId("");
  //     } else if (type === "Attendance") {
  //       setUsersId("");
  //     }
  //     //setUsersId("");
  //   }
  // };

  const getuserOnchange1 = (e, type) => {
    if (e !== null) {
      const alluserId =
        userListByCompanyForAttendance &&
        userListByCompanyForAttendance.map((val) => {
          return val.id;
        });
      if (e[0]?.id === "All") {
        if (type === "StandLive") {
          setStandLiveUserId(alluserId);
        } else if (type === "Attendance") {
          setUsersId(alluserId);
        }
        // setUsersId(alluserId);
      } else if (e[0]?.id !== "All") {
        const multiselectId =
          e &&
          e.map((val) => {
            return val.id;
          });

        if (type === "StandLive") {
          setStandLiveUserId(multiselectId);
        } else if (type === "Attendance") {
          setUsersId(multiselectId);
        }
        // setUsersId(multiselectId);
      }
    } else {
      if (type === "StandLive") {
        setStandLiveUserId("");
      } else if (type === "Attendance") {
        setUsersId("");
      }
      //setUsersId("");
    }
  };

  const fetchAttendancePremisonList = () => {
    // if ((companyId === undefined || companyId === null)) {
    //     alert("Please Select Company!")
    //     return false
    // }
    const hrmsToken = JSON.parse(localStorage.getItem("data")).hrmsToken;

    const data = {
      companyId: companyId ? companyId.id : null,
      siteId: siteId?.id || null,
      authToken: hrmsToken,
    };
    companyWiseEmp.fetchattendenceconfigurationList(data).then((response) => {
      if (response !== null) {
        setAttendanceShowPremison(response.data);
        if (response.responseCode === 404) {
          alert("No record found ");
          setAttendanceShowPremison([]);
        }
      } else {
      }
    });
  };

  const fetchcompanyclientstatusDataList = () => {
    //setOnyShowHeader(true)
    //fetchClientBaseEmp()
    const data = {
      hrmsCompanyId: companyId ? companyId.id : null,
    };
    companyWiseEmp.fetchcompanyclientstatusmaster(data).then((response) => {
      if (response !== null) {
        setSortedList(response.data);

        if (response.responseCode === 404) {
          setSortedList([]);
          alert("No record found Status List!!");
          setOnyShowHeader(true);
        }
      } else {
        setSortedList([]);
      }
    });
  };

  const fetchGeofancePremisonList = () => {
    const data = {
      companyId: companyId ? companyId.id : null,
    };
    companyWiseEmp.fetchattendenceconfigurationList(data).then((response) => {
      if (response !== null) {
        setgeoFanceShowPremison(response.data);
        if (response.responseCode === 404) {
          alert("No record found ");
          setgeoFanceShowPremison([]);
        }
      } else {
        setgeoFanceShowPremison([]);
      }
    });
  };

  const getTempalte = () => {
    const data = {
      companyId: companyId ? companyId.id : null,
      templateTypeId: 5,
    };
    dynamiceForm.fetchGetSaveTempalte(data).then((response) => {
      if (response !== null) {
        setHeaderName(response.data.templateDateForAindroid);
      }
    });
  };
  console.log(headerName, "headerName");

  const handleSaveLayout = () => {
    //   const Jsndata=[]
    //   Jsndata.push([headerName,{actualName:AddTitleValue,displayName:AddTitleValue}])
    //  console.log(Jsndata,"Jsndata")

    // let resultToReturn = false;
    // const headerNameList = headerName.map((val) => val.actualName);
    // resultToReturn = headerNameList.some((element, index) => {
    //   return headerNameList.indexOf(element) !== index;
    // });

    // if (resultToReturn === true) {
    //   alert("Duplicates dont exist ");
    //   return false;
    // }
    const finalArray =
      headerName &&
      headerName.map((val) => {
        const arrayList = {
          Show: false,
          orderId: val.orderId,
          actualName: val.actualName,
          displayName: val.displayName,
        };
        return arrayList;
      });
    console.log(finalArray, "finalArray");
    if (headerName.length === 0) {
      alert("Please Add Title!");
      return false;
    } else if (
      finalArray.length > 0 &&
      finalArray[finalArray.length - 1].actualName === ""
    ) {
      alert("Status should not be empty!");
      return false;
    }

    const data = {
      companyId: companyId ? companyId.id : null,
      templateTypeId: 5,
      templateData: finalArray,
    };

    dynamiceForm.fetchSaveTempalte(data).then((response) => {
      if (response == null) {
        setShowEdite(false);
        getTempalte();
        alert("Data saved Successfully!!");
      } else {
      }
    });
    localStorage.removeItem("llayout");
    // addLayout(layouts);
  };

  const getOnchangevalue = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...headerName];
    onchangeVal[i]["displayName"] = value;
    setHeaderName(onchangeVal);
    console.log((onchangeVal[i][name] = value), "hvferfwurrg");
  };
  const addTitleHnadler = () => {
    setAddTitleValue(true);
    setHeaderName([
      ...headerName,
      {
        Show: true,
        orderId: headerName.length - 1 + 1,
        actualName: "",
        displayName: "",
      },
    ]);
  };
  const editeHandler = (data) => {
    setStatausValue(data.displayName);
    setShowEdite(true);
    setEditValue(data.actualName);
  };
  const rowDeleteHandler = (row) => {
    const DeleteFilter =
      headerName && headerName.filter((val) => val.actualName !== row);
    setHeaderName(DeleteFilter);
  };
  const closeSaveHandler = () => {
    setShowEdite(false);
    //setEditValue(null);
  };

  const openDyanamiceForm = (type) => {
    localStorage.removeItem("subTemplateId");
    if (type === "MettingDetails") {
      navigate(`/CreateDynamiceForm/${type}`);
    } else if (isMultipleFormForClientShow && type === "clentsDetails") {
      navigate("/clientDynamicFormTemplateList");
    } else if (type === "clentsDetails") {
      navigate(`/CreateDynamiceForm/${type}`);
    } else {
      navigate(`/${type}`);
    }
  };

  // const gpsLocationStatusObj =
  //   CompanyConfigurationData?.find(
  //     (confName) => confName.hrmsConfigurationName === "GPS_LOCATION_STATUS"
  //   ) || null;

  const gpsLocationStatusObj =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName === "ENABLE_GPS_LOSS_NOTIFICATION",
    ) || null;

  const gpsNotificationUserObj =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName ===
        "ENABLE_SHIFT_COMPLETION_NOTIFICATION",
    ) || null;

  const isMeetingSubmissionPushNotificationShow =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName ===
        "MEETING_SUBMISSION_PUSH_NOTIFICATION",
    )?.isEnable || false;

  const isGpsLossNotificationShow =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName === "ENABLE_GPS_LOSS_NOTIFICATION",
    )?.isEnable || false;

  const isShiftCompletionNotificationShow =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName ===
        "ENABLE_SHIFT_COMPLETION_NOTIFICATION",
    )?.isEnable || false;

  const isMultipleFormForClientShow =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName === "ENABLE_MULTIPLE_FORM_FOR_CLIENT",
    )?.isEnable || false;

  const isUserReibursementShow =
    CompanyConfigurationData?.find(
      (confName) =>
        confName.hrmsConfigurationName === "ENABLE_REIMBERSUMENT_CONFIGURATION",
    )?.isEnable || false;

  const isUserSitePermissionShow =
    CompanyConfigurationData?.find(
      (confName) => confName.hrmsConfigurationName === "ENABLE_SITE_CONFIG",
    )?.isEnable || false;

  useEffect(() => {
    fetchCompanyList();
    fetchOwnerList();
  }, []);
  // const selectCompanyId=JSON.parse(localStorage.getItem("CompanyId").id)
  // console.log(selectCompanyId,"selectCompanyId")

  useEffect(() => {
    if (companyId?.id) {
      fetchCompanyWiseSiteList();
    } else {
      setSiteList([]);
    }
    setSiteId(null);
  }, [companyId]);

  const topViewNavData = {
    title: "Company/Emp wise configuration",
    backPathRoute: "/dashboard",
  };
  return (
    <div>
      <main className="contents__root">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
              }}
            >
              <TopViewNav
                topViewNavData={topViewNavData}
                clientSatatusBtn={
                  companyIdByBtn && companyIdByBtn ? true : false
                }
                openDyanamiceForm={openDyanamiceForm}
              />
            </Box>
          </Grid>
          <Container sx={{ paddingBottom: "20px" }} maxWidth="true">
            <Grid
              container
              spacing={2}
              style={{ placeItems: "center", justifyContent: "end" }}
            >
              <ViewCompanyPremisson
                openModal={openModal}
                setOpenModal={setOpenModal}
                ModalType={ModalType}
                AttendanceShowPremison={AttendanceShowPremison}
                geofanceShowPremison={geofanceShowPremison}
                fetchAttendancePremisonList={fetchAttendancePremisonList}
              />
            </Grid>
          </Container>

          <Grid className="CompanyBox">
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              gap="5px"
              alignItems="center"
            >
              <div className="field_box">
                <Autocomplete
                  size="small"
                  id="header"
                  className="select_box"
                  options={companyList || []}
                  getOptionLabel={(option) => `${option.companyName}`}
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    setCompanyId(newValue);

                    // localStorage.removeItem("CompanyId")
                  }}
                  renderOption={(props, option) => {
                    return (
                      <List
                        sx={{ opacity: option.id == 0 ? ".5" : "1" }}
                        {...props}
                        key={option.id}
                      >
                        {`${option.companyName}`}
                      </List>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="Select Company"
                    />
                  )}
                />
              </div>
              {companyId &&
              companyId?.id === companyIdByBtn &&
              originalEnableSiteConfiguration ? (
                // companyId?.isSiteConfigEnabled
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    id="header"
                    className="select_box"
                    value={siteId || null}
                    options={siteList || []}
                    getOptionLabel={(option) => `${option?.name}`}
                    disablePortal={true}
                    fullWidth
                    onChange={(event, newValue) => {
                      setSiteId(newValue);

                      // localStorage.removeItem("CompanyId")
                    }}
                    renderOption={(props, option) => {
                      return (
                        <List
                          sx={{ opacity: option.id == 0 ? ".5" : "1" }}
                          {...props}
                          key={option.id}
                        >
                          {`${option.name}`}
                        </List>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select Site"
                      />
                    )}
                  />
                </div>
              ) : (
                ""
              )}

              <div className="field_box">
                <Autocomplete
                  size="small"
                  id="header"
                  className="select_box"
                  options={userList || []}
                  getOptionLabel={(option) =>
                    `${option.name}(${option.empCode})`
                  }
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    setUserId(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="User"
                    />
                  )}
                />
              </div>
              <div className="field_box">
                <div
                  className="field_box_btn"
                  onClick={fetchClientBaseEmp}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  Submit
                </div>
              </div>
            </Grid>
          </Grid>

          {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <Accordion className="main_accoardian" defaultExpanded={true}>
                <AccordionSummary
                  className="accordianHeader"
                  expandIcon={
                    <AddCircleIcon
                      fontSize="large"
                      style={{ color: "white" }}
                    />
                  }
                  aria-controls="panel1a-content"
                  style={{
                    background: "rgb(10 166 141)",
                    borderRadius: "10px 10px 0px 0px",
                    overflow: "hidden",
                  }}
                >
                  <Grid>
                    <h3
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      Company Base Configuration:-
                    </h3>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails className="accoardian_body">
                  <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                    <TableContainer component={Paper}>
                      <Table size="small" aria-label="a dense table">
                        <TableHead
                          style={{ color: "#fff", backgroundColor: "#32577e" }}
                        >
                          <TableCell className="tabalecellStyle">
                            S.no
                          </TableCell>
                          <TableCell className="tabalecellStyle">
                            Status Change Configuration
                          </TableCell>
                          <TableCell className="tabalecellStyle">
                            Configuration Status
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>1</TableCell>
                            <TableCell>
                              Meeting start and End option for duration
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={meetingStart}
                                onChange={(e) => mettintingstarthandler(e)}
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>2</TableCell>
                            <TableCell>
                              Schedule meeting follow up with date or without
                              datetime
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={AttendanceStart}
                                onChange={(e) => AttendanceHnadler(e)}
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>3</TableCell>
                            <TableCell>All client or own client view</TableCell>
                            <TableCell>
                              <Switch
                                checked={AllclinetView}
                                onChange={(e) =>
                                  setAllclinetView(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>4</TableCell>
                            <TableCell>Single meeting distance</TableCell>
                            <TableCell>
                              <Switch
                                checked={singleMetting}
                                onChange={(e) =>
                                  setSingleMetting(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>5</TableCell>
                            <TableCell>None BackWord</TableCell>
                            <TableCell>
                              <Switch
                                checked={BackWordStatus}
                                onChange={(e) =>
                                  setBackWordStatus(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>6</TableCell>
                            <TableCell>Can change From Final Status</TableCell>
                            <TableCell>
                              <Switch
                                checked={FinalStatus}
                                onChange={(e) =>
                                  setFinalStatus(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>7</TableCell>
                            <TableCell>Can Change only One Level</TableCell>
                            <TableCell>
                              <Switch
                                checked={FixedOrderStataus}
                                onChange={(e) =>
                                  setFixedOrderStataus(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>8</TableCell>
                            <TableCell>
                              Show Locality On Order Creation
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={showLocalityOnOrder}
                                onChange={(e) =>
                                  setShowLocalityOnOrder(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>9</TableCell>
                            <TableCell>Enable Unit Conversion</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableUnitConversion}
                                onChange={(e) =>
                                  setEnableUnitConversion(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>10</TableCell>
                            <TableCell>Allow Orders With Decimal</TableCell>
                            <TableCell>
                              <Switch
                                checked={allowOrderWithDecimal}
                                onChange={(e) =>
                                  setAllowOrderWithDecimal(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>11</TableCell>
                            <TableCell>GST and PAN Mandetory</TableCell>
                            <TableCell>
                              <Switch
                                checked={gstAndPan}
                                onChange={(e) => setGstAndPan(e.target.checked)}
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>12</TableCell>
                            <TableCell>Enable WhatsApp</TableCell>
                            <TableCell>
                              <Switch
                                checked={isWhatsApp}
                                onChange={(e) =>
                                  setIsWhatsApp(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>13</TableCell>
                            <TableCell>Enable Bank Details</TableCell>
                            <TableCell>
                              <Switch
                                checked={isBankDetails}
                                onChange={(e) =>
                                  setIsBankDetails(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>14</TableCell>
                            <TableCell>Enable Auto Default Meeting</TableCell>
                            <TableCell>
                              <Switch
                                checked={isDefaultMeeting}
                                onChange={(e) =>
                                  setIsDefaultMeeting(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>15</TableCell>
                            <TableCell>Enable Multi Level Approver</TableCell>
                            <TableCell>
                              <Switch
                                checked={isMultiLevelApprover}
                                onChange={(e) =>
                                  setIsMultiLevelApprover(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>16</TableCell>
                            <TableCell>Enable Bulk Approve Expense</TableCell>
                            <TableCell>
                              <Switch
                                checked={isExpenseBulkApprove}
                                onChange={(e) =>
                                  setIsExpenseBulkApprove(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>17</TableCell>
                            <TableCell>Enable Undertaking Form</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableUndertakingForm}
                                onChange={(e) =>
                                  setEnableUndertakingForm(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>18</TableCell>
                            <TableCell>Show GPS Location Status</TableCell>
                            <TableCell>
                              <Switch
                                checked={showGPSLoationStatus}
                                onChange={(e) =>
                                  setShowGPSLoationStatus(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>19</TableCell>
                            <TableCell>
                              Enable Remark on Default Meeting
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isRemarkEnableForDefaultMeeting}
                                onChange={(e) =>
                                  setIsRemarkEnableForDefaultMeeting(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>20</TableCell>
                            <TableCell>
                              Meeting Submission Push Notification
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isMeetingSubmissionPushNotification}
                                onChange={(e) =>
                                  setIsMeetingSubmissionPushNotification(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>21</TableCell>
                            <TableCell>Enable GPS Loss Notification</TableCell>
                            <TableCell>
                              <Switch
                                checked={isGpsLossNotification}
                                onChange={(e) =>
                                  setIsGpsLossNotification(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>22</TableCell>
                            <TableCell>
                              Enable Shift Completion Notification
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isShiftCompletionNotification}
                                onChange={(e) =>
                                  setIsShiftCompletionNotification(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>23</TableCell>
                            <TableCell>
                              User Login Permission Configuration
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={showUserLoginPermissionConfig}
                                onChange={(e) =>
                                  setShowUserLoginPermissionConfig(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>24</TableCell>
                            <TableCell>Show Audio Option</TableCell>
                            <TableCell>
                              <Switch
                                checked={showAudioOption}
                                onChange={(e) =>
                                  setShowAudioOption(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>25</TableCell>
                            <TableCell>
                              Enable Multiple Form For Client
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isMultipleFormForClient}
                                onChange={(e) =>
                                  setIsMultipleFormForClient(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>26</TableCell>
                            <TableCell>
                              Reimbursement Access Permission
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isReimbursementAccess}
                                onChange={(e) =>
                                  setIsReimbursementAccess(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>27</TableCell>
                            <TableCell>Enable Add Client On Web</TableCell>
                            <TableCell>
                              <Switch
                                checked={isAddClientWeb}
                                onChange={(e) =>
                                  setIsAddClientWeb(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>28</TableCell>
                            <TableCell>Enable Background Service</TableCell>
                            <TableCell>
                              <Switch
                                checked={isBackgroundServiceEnable}
                                onChange={(e) =>
                                  setIsBackgroundServiceEnable(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>29</TableCell>
                            <TableCell>Companywise API data sync</TableCell>
                            <TableCell>
                              <Switch
                                checked={isCompanyWiseApiDataSync}
                                onChange={(e) =>
                                  setIsCompanyWiseApiDataSync(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>30</TableCell>
                            <TableCell>
                              Allow Actual Path-Based Route Creation
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={showActualPath}
                                onChange={(e) =>
                                  setShowActualPath(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>31</TableCell>
                            <TableCell>
                              Enable Live Tracking From Dashboard
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={showLiveTracking}
                                onChange={(e) =>
                                  setShowLiveTracking(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>32</TableCell>
                            <TableCell>
                              Route creation through OD On/Off
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableLiveTrackingOnOdWithoutMeeting}
                                onChange={(e) =>
                                  setEnableLiveTrackingOnOdWithoutMeeting(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>33</TableCell>
                            <TableCell>
                              Meeting Wise Route and Distance
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={showRouteAndResponse}
                                onChange={(e) =>
                                  setShowRouteAndResponse(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>34</TableCell>
                            <TableCell>
                              Single Device Login Permission
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={singleDeviceLoginPermission}
                                onChange={(e) =>
                                  setSingleDeviceLoginPermission(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>35</TableCell>
                            <TableCell>
                              Meeting Submit Without Location Restriction{" "}
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  isMeetingSubmitWithoutLocationRestriction
                                }
                                onChange={(e) =>
                                  setIsMeetingSubmitWithoutLocationRestriction(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>36</TableCell>
                            <TableCell>Enable Ads Configuration</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableAdsConfig}
                                onChange={(e) =>
                                  setEnableAdsConfig(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>37</TableCell>
                            <TableCell>
                              Enable Image Upload In Default Meeting
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isImageUploadEnableInDefaultMeeting}
                                onChange={(e) =>
                                  setIsImageUploadEnableInDefaultMeeting(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>38</TableCell>
                            <TableCell>
                              Enable Multiple Tracking Data For Single Day
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableMultipleTrackingDataForSingleDay}
                                onChange={(e) =>
                                  setEnableMultipleTrackingDataForSingleDay(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>39</TableCell>
                            <TableCell>
                              Enable Odometer Reading Required On OD
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={odometerReadingRequiredOnOd}
                                onChange={(e) =>
                                  setOdometerReadingRequiredOnOd(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          {siteIdByBtn ? (
                            ""
                          ) : (
                            <TableRow>
                              <TableCell>40</TableCell>
                              <TableCell>Enable Site Configuration</TableCell>
                              <TableCell>
                                <Switch
                                  checked={enableSiteConfiguration}
                                  onChange={(e) =>
                                    setEnableSiteConfiguration(e.target.checked)
                                  }
                                  color="secondary"
                                />
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow>
                            <TableCell>41</TableCell>
                            <TableCell>
                              Enable Schedule Meetings Through Excel Import
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableScheduleMeetingBulkApprove}
                                onChange={(e) =>
                                  setEnableScheduleMeetingBulkApprove(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>42</TableCell>
                            <TableCell>Enable HRMS Department</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableHrmsDepartment}
                                onChange={(e) =>
                                  setEnableHrmsDepartment(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>43</TableCell>
                            <TableCell>Enable HRMS Sub-Department</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableSubDepartment}
                                onChange={(e) =>
                                  setEnableSubDepartment(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>43</TableCell>
                            <TableCell>
                              Enable Od Restriction On Holidays/Week-Offs
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableOdRestrictionsOnWeekOffs}
                                onChange={(e) =>
                                  setEnableOdRestrictionsOnWeekOffs(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          {/* <TableRow>
                            <TableCell>44</TableCell>
                            <TableCell>
                              OD / Device Restore Access Permission
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableOdRestoration}
                                onChange={(e) =>
                                  setEnableOdRestoration(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow> */}

                          {/* <TableRow>
                            <TableCell>44</TableCell>
                            <TableCell>
                              Enable Meeting Auto-Submit After Certain Distance
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  enableMeetingAutoSubmitAfterCertainDistance
                                }
                                onChange={(e) =>
                                  setEnableMeetingAutoSubmitAfterCertainDistance(
                                    e.target.checked
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow> */}

                          <TableRow>
                            <TableCell>44</TableCell>
                            <TableCell>
                              Enable Company Permission Configuration
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={enableCompanyPermissionConfiguration}
                                onChange={(e) =>
                                  setEnableCompanyPermissionConfiguration(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>45</TableCell>
                            <TableCell>Enable Geofence Management</TableCell>
                            <TableCell>
                              <Switch
                                checked={enableGeofenceManagement}
                                onChange={(e) =>
                                  setEnableGeofenceManagement(e.target.checked)
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>46</TableCell>
                            <TableCell>
                              Enable Company Wise Meeting Data Sync
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={isCompanyWiseMeetingDataSync}
                                onChange={(e) =>
                                  setIsCompanyWiseMeetingDataSync(
                                    e.target.checked,
                                  )
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>47</TableCell>
                            <TableCell>Enable Show Longest Path</TableCell>
                            <TableCell>
                              <Switch
                                checked={state.isShowLongestPath}
                                onChange={(e) =>
                                  dispatch({
                                    type: "LONGEST_PATH",
                                    payload: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>48</TableCell>
                            <TableCell>
                              Enable Default Meeting Within Geofence
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  state.isEnableDefaultMeetingWithinGeofence
                                }
                                onChange={(e) =>
                                  dispatch({
                                    type: "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE",
                                    payload: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>49</TableCell>
                            <TableCell>
                              Enable User Wise Google Route Map
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  state.isEnableCompanyWiseUserGoogleRouteMode
                                }
                                onChange={(e) =>
                                  dispatch({
                                    type: "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE",
                                    payload: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>50</TableCell>
                            <TableCell>
                              Start OD Automatically After Midnight
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  state.isStartOdAutomaticallyAfterMidnight
                                }
                                onChange={(e) =>
                                  dispatch({
                                    type: "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT",
                                    payload: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>51</TableCell>
                            <TableCell>
                              Disable Default Meeting Without Info
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={
                                  state.isDisableDefaultMeetingWithoutInfo
                                }
                                onChange={(e) =>
                                  dispatch({
                                    type: "DISABLE_DEFAULT_MEETING_WITHOUT_INFO",
                                    payload: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Grid
                      style={{
                        placeItems: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "10px",
                      }}
                    >
                      <div className="field_box">
                        <div
                          className="field_box_btn1"
                          onClick={fetchCompanyConfiguration}
                          style={{
                            cursor: "pointer",
                            width: "60px",
                          }}
                        >
                          Save
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          {/* isUserSitePermissionShow */}

          {false && Boolean(companyIdByBtn) && isUserSitePermissionShow && (
            <Grid className="CompanyBox">
              <UserSitePermission
                userList={userList}
                companyId={companyIdByBtn}
                siteId={siteIdByBtn}
              />
            </Grid>
          )}

          {Boolean(companyIdByBtn) && isUserReibursementShow && (
            <Grid className="CompanyBox">
              <UserReimbursement
                companyId={companyIdByBtn}
                siteId={siteIdByBtn}
              />
            </Grid>
          )}

          {Boolean(companyIdByBtn) && showUserLoginPermissionConfig && (
            <Grid className="CompanyBox">
              <UserLoginConfiguration
                companyId={companyId}
                userLoginPermissionCacheuster={userLoginPermissionCacheuster}
                siteId={siteIdByBtn}
              />
            </Grid>
          )}

          {Boolean(companyIdByBtn) &&
            isMeetingSubmissionPushNotificationShow && (
              <Grid className="CompanyBox">
                <GeofenceDistanceConfiguration
                  companyId={companyIdByBtn}
                  siteId={siteIdByBtn}
                />
              </Grid>
            )}

          {CompanyConfigurationData.length > 0 &&
            Boolean(companyIdByBtn) &&
            Boolean(enableUndertakingForm) && (
              <Grid className="CompanyBox">
                <UnderTakingFormUpload companyId={companyIdByBtn} />
              </Grid>
            )}

          {Boolean(companyIdByBtn) && (
            <Grid className="CompanyBox">
              <UserEnableDisableConfiguration
                companyId={companyIdByBtn}
                siteId={siteIdByBtn}
              />
            </Grid>
          )}

          {Boolean(companyIdByBtn) &&
            CompanyConfigurationData.some(
              (config) =>
                config.hrmsConfigurationName ===
                  "THIRD_PARTY_API_SYNC_FOR_CLIENT" && config.isEnable === true,
            ) && (
              <Grid className="CompanyBox">
                <CompanyWiseApiDataSync companyId={companyIdByBtn} />
              </Grid>
            )}

          {/* {Boolean(companyIdByBtn) && (
            <Grid className="CompanyBox">
              <CompanyWiseApiDataSync companyId={companyIdByBtn} />
            </Grid>
          )} */}

          {Boolean(companyIdByBtn) &&
            // gpsLocationStatusObj?.isEnable
            isGpsLossNotificationShow && (
              <Grid className="CompanyBox">
                <GpsNotificationConfiguration
                  gpsLocationStatusObj={gpsLocationStatusObj}
                  companyId={companyIdByBtn}
                />
              </Grid>
            )}

          {Boolean(companyIdByBtn) &&
            //  Boolean(gpsNotificationUserObj)
            isShiftCompletionNotificationShow && (
              <Grid className="CompanyBox">
                <UserGpsNotificationConfiguration
                  companyId={companyIdByBtn}
                  gpsNotificationUserObj={gpsNotificationUserObj}
                />
              </Grid>
            )}

          {Boolean(companyIdByBtn) && (
            <Grid className="CompanyBox">
              <OrderManagementHeaderConfiguration companyId={companyIdByBtn} />
            </Grid>
          )}

          {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <Accordion className="main_accoardian" defaultExpanded={true}>
                <AccordionSummary
                  className="accordianHeader"
                  expandIcon={
                    <AddCircleIcon
                      fontSize="large"
                      style={{ color: "white" }}
                    />
                  }
                  aria-controls="panel1a-content"
                  style={{
                    background: "rgb(10 166 141)",
                    borderRadius: "10px 10px 0px 0px",
                    overflow: "hidden",
                  }}
                >
                  <Grid>
                    <h3
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      Header Configuration:-
                    </h3>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails className="accoardian_body">
                  <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                    <Grid
                      style={{
                        placeItems: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0",
                      }}
                    >
                      <div className="field_box">
                        <div
                          className="field_box_btn1"
                          onClick={addTitleHnadler}
                          style={{
                            cursor: "pointer",
                            width: "60px",
                          }}
                        >
                          Add
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                    <TableContainer component={Paper}>
                      <Table size="small" aria-label="a dense table">
                        <TableHead
                          style={{ color: "#fff", backgroundColor: "#32577e" }}
                        >
                          <TableCell className="tabalecellStyle">
                            S.no
                          </TableCell>
                          <TableCell className="tabalecellStyle">
                            Actual Title Name
                          </TableCell>
                          <TableCell className="tabalecellStyle">
                            Current Title Name
                          </TableCell>
                          <TableCell className="tabalecellStyle">
                            Action
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          {headerName &&
                            headerName.map((val, ind) => {
                              return (
                                <>
                                  <TableRow>
                                    <TableCell>{ind + 1}</TableCell>
                                    <TableCell>
                                      {val.Show === true ? (
                                        <TextField
                                          id="outlined-required"
                                          label="Add your  Title"
                                          variant="standard"
                                          name="actualName"
                                          value={val.actualName}
                                          onChange={(e) =>
                                            getOnchangevalue(e, ind)
                                          }
                                        />
                                      ) : (
                                        val.actualName
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {showEditValue === true &&
                                      editeValue === val.actualName ? (
                                        <TextField
                                          id="outlined-required"
                                          label="Edit your  Title"
                                          variant="standard"
                                          name="displayName"
                                          value={val.displayName}
                                          onChange={(e) =>
                                            getOnchangevalue(e, ind)
                                          }
                                        />
                                      ) : val.Show == true ? (
                                        ""
                                      ) : (
                                        val && val.displayName
                                      )}
                                      {/* {val.actualName == null ? (
                                        <TextField
                                          required
                                          id="outlined-required"
                                          label="Enter your title"
                                          variant="standard"
                                          // sx={{width:"150px"}}
                                          name="displayName"
                                          value={val.displayName}
                                          onChange={(e) =>
                                            getOnchangevalue(e, ind)
                                          }
                                        />
                                      ) : showEditValue === true &&
                                        editeValue === val.actualName ? (
                                        <TextField
                                          required
                                          id="outlined-required"
                                          label="Edit your  status"
                                          variant="standard"
                                          // name="statusName"
                                          value={statausValue}
                                          onChange={(e) =>
                                            setStatausValue(e.target.value)
                                          }
                                        />
                                      ) : val.displayName ? (
                                        val.displayName
                                      ) : (
                                        "NA"
                                      )} */}
                                    </TableCell>
                                    <TableCell>
                                      {showEditValue === true &&
                                      editeValue === val.actualName ? (
                                        ""
                                      ) : (
                                        <Tooltip title="Edit Title">
                                          <IconButton
                                            style={{ color: "green" }}
                                            onClick={() => editeHandler(val)}
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        </Tooltip>
                                      )}

                                      {showEditValue === true &&
                                      editeValue === val.actualName ? (
                                        <Tooltip title="Close">
                                          <IconButton
                                            style={{ color: "red" }}
                                            onClick={() => closeSaveHandler()}
                                          >
                                            <CloseIcon />
                                          </IconButton>
                                        </Tooltip>
                                      ) : (
                                        ""
                                      )}
                                      <IconButton
                                        onClick={() =>
                                          rowDeleteHandler(val.actualName)
                                        }
                                      >
                                        <DeleteIcon sx={{ color: "red" }} />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                </>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Grid
                      style={{
                        placeItems: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "10px",
                      }}
                    >
                      <div className="field_box">
                        <div
                          className="field_box_btn1"
                          onClick={handleSaveLayout}
                          style={{
                            cursor: "pointer",
                            width: "60px",
                          }}
                        >
                          Save
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}

          {/* default meeting configuration */}
          {Boolean(companyIdByBtn) && isDefaultMeeting && (
            <Grid className="CompanyBox">
              <DefaultMeetingConfiguration
                companyId={companyIdByBtn}
                siteId={siteIdByBtn}
              />
            </Grid>
          )}

          {/* OD Restore Configuration */}
          {Boolean(companyIdByBtn) && (
            <Grid className="CompanyBox">
              <OdRestoreConfiguration userList={userListByCompany} />
            </Grid>
          )}

          {/* OD RESTORATION */}
          {Boolean(companyIdByBtn) && enableCompanyPermissionConfiguration && (
            <Grid className="CompanyBox">
              {/* <DeviceRestoreConfiguration userList={userListByCompany} /> */}
              <OdRestorationConfiguration
                userList={userListByCompany}
                companyId={companyIdByBtn}
              />
            </Grid>
          )}

          {Boolean(companyIdByBtn) && enableAdsConfig && (
            <Grid className="CompanyBox">
              <CompanyAdsConfiguration companyId={companyIdByBtn} />
            </Grid>
          )}

          {/* Device Restore Configuration */}
          {Boolean(companyIdByBtn) &&
            CompanyConfigurationData.some(
              (config) =>
                config.hrmsConfigurationName ===
                  "SINGLE_DEVICE_LOGIN_PERMISSION" && config.isEnable === true,
            ) && (
              <Grid className="CompanyBox">
                <DeviceRestoreConfiguration userList={userListByCompany} />
              </Grid>
            )}

          {/* Multi Level Approver Configuration */}
          {/* {Boolean(companyIdByBtn) && Boolean(isMultiLevelApprover) && (
            <Grid className="CompanyBox">
              <MultiLevelApproverConfiguration
                userList={userListByCompany}
                companyId={companyId}
                isMultiLevelApprover={isMultiLevelApprover}
              />
            </Grid>
          )} */}

          {/* client permission configuration */}
          {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <ClientPermissionConfiguration userList={userListByCompany} />
            </Grid>
          )}

          {Boolean(companyIdByBtn) && (
            <Grid className="CompanyBox">
              <CameraConfiguration companyId={companyIdByBtn} />
            </Grid>
          )}

          {CompanyConfigurationData.length > 0 &&
            CompanyConfigurationData.find(
              (item) => item.hrmsConfigurationName === "WHATSAPP_ENABLE",
            )?.isEnable === true && (
              <Grid className="CompanyBox">
                <Accordion className="main_accoardian" defaultExpanded={true}>
                  <AccordionSummary
                    className="accordianHeader"
                    expandIcon={
                      <AddCircleIcon
                        fontSize="large"
                        style={{ color: "white" }}
                      />
                    }
                    aria-controls="panel1a-content"
                    style={{
                      background: "rgb(10 166 141)",
                      borderRadius: "10px 10px 0px 0px",
                      overflow: "hidden",
                    }}
                  >
                    <Grid>
                      <Grid>
                        <h3
                          style={{
                            color: "#fff",
                            marginLeft: "10px",
                            padding: "10px 2px",
                          }}
                        >
                          Whatsapp Configuration:-
                        </h3>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid>
                      <Box>
                        <Grid
                          container
                          direction="row"
                          //justifyContent="center"
                          spacing={3}
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <Grid
                              container
                              direction="row"
                              //justifyContent="center"
                              spacing={3}
                              alignItems="center"
                            >
                              <Grid item md={3.55} lg={2.75} xl={2.25}>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  required
                                  value={
                                    whatsappConfigurationFormData?.maxMonthLimit
                                  }
                                  id="outlined-basic"
                                  label="Monthly Max Limit"
                                  name="monthlyMaxLimit"
                                  variant="outlined"
                                  size="small"
                                  inputProps={{ maxLength: 8 }}
                                  onChange={(e) =>
                                    setWhatsappConfigurationFormData(
                                      (prevData) => ({
                                        ...prevData,
                                        maxMonthLimit: e.target.value.replace(
                                          /\D/g,
                                          "",
                                        ),
                                      }),
                                    )
                                  }
                                />
                              </Grid>

                              <Grid item>
                                <div
                                  className="field_box"
                                  style={{
                                    // backgroundColor: "orange",
                                    paddingBottom: "12px",
                                  }}
                                >
                                  <div
                                    className="field_box_btn1"
                                    onClick={() =>
                                      fetchSaveWhatsappMaxMessageLimit()
                                    }
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    Save Max Limit
                                  </div>
                                </div>
                              </Grid>
                              <Grid item>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  // required
                                  value={
                                    whatsappConfigurationFormData?.currentMonthLimit
                                  }
                                  id="outlined-basic"
                                  label="Available Limit"
                                  name="currentMonthLimit"
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => e?.preventDefault()}
                                />
                              </Grid>

                              <Grid item>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  // required
                                  // value={
                                  //   whatsappConfigurationFormData?.lastSentOn ||
                                  //   ""
                                  // }
                                  value={
                                    whatsappConfigurationFormData?.lastSentOn
                                      ? moment(
                                          whatsappConfigurationFormData?.lastSentOn,
                                        ).format("DD/MM/YYYY hh:mm A")
                                      : "dd/mm/yyyy"
                                  }
                                  id="outlined-basic"
                                  label="Last Message Sent On"
                                  name="lastMessageSentOn"
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => e?.preventDefault()}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid
                              container
                              direction="row"
                              //justifyContent="center"
                              spacing={3}
                              alignItems="center"
                            >
                              <Grid item md={3.55} lg={2.75} xl={1.8}>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  required
                                  value={
                                    whatsappConfigurationFormData?.fromDate
                                  }
                                  id="outlined-number"
                                  label="From Date"
                                  type="date"
                                  name="fromDate"
                                  variant="outlined"
                                  size="small"
                                  inputProps={{
                                    max: whatsappConfigurationFormData?.toDate
                                      ? whatsappConfigurationFormData?.toDate
                                      : new Date().toISOString().split("T")[0],
                                  }}
                                  onChange={(e) =>
                                    setWhatsappConfigurationFormData(
                                      (prevData) => ({
                                        ...prevData,
                                        fromDate: e.target.value,
                                        counts: 0,
                                      }),
                                    )
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </Grid>

                              <Grid item md={3.55} lg={2.75} xl={1.8}>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  required
                                  value={whatsappConfigurationFormData?.toDate}
                                  id="outlined-number"
                                  label="To Date"
                                  type="date"
                                  name="toDate"
                                  variant="outlined"
                                  size="small"
                                  inputProps={{
                                    min: whatsappConfigurationFormData?.fromDate,
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                  onChange={(e) =>
                                    setWhatsappConfigurationFormData(
                                      (prevData) => ({
                                        ...prevData,
                                        toDate: e.target.value,
                                        counts: 0,
                                      }),
                                    )
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </Grid>
                              <Grid item>
                                <div
                                  className="field_box"
                                  style={{
                                    // backgroundColor: "orange",
                                    paddingBottom: "12px",
                                  }}
                                >
                                  <div
                                    className="field_box_btn1"
                                    onClick={() =>
                                      fetchGetCompanywiseWhatsappMessageCount()
                                    }
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    Check
                                  </div>
                                </div>
                              </Grid>
                              <Grid item>
                                <CustomInputField
                                  sx={{
                                    width: "100%",
                                    margin: "0px !important",
                                  }}
                                  // required
                                  value={whatsappConfigurationFormData?.counts}
                                  id="outlined-basic"
                                  label="Counts"
                                  name="counts"
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => e?.preventDefault()}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* <Grid item xs={12}></Grid> */}
                        </Grid>
                      </Box>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            )}

          {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <OrderManagementConfiguration userList={userListByCompany} />
            </Grid>
          )}

          {CompanyConfigurationData.length > 0 &&
            isBankDetails &&
            Boolean(companyIdByBtn) && (
              <Grid className="CompanyBox">
                <BankDetailsConfiguration companyId={companyIdByBtn} />
              </Grid>
            )}

          {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <Accordion className="main_accoardian" defaultExpanded={true}>
                <AccordionSummary
                  className="accordianHeader"
                  expandIcon={
                    <AddCircleIcon
                      fontSize="large"
                      style={{ color: "white" }}
                    />
                  }
                  aria-controls="panel1a-content"
                  style={{
                    background: "rgb(10 166 141)",
                    borderRadius: "10px 10px 0px 0px",
                    overflow: "hidden",
                  }}
                >
                  <Grid>
                    <Grid>
                      <h3
                        style={{
                          color: "#fff",
                          marginLeft: "10px",
                          padding: "10px 2px",
                        }}
                      >
                        User Base Configuration:-
                      </h3>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className="accoardian_body">
                  <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                    <Grid>
                      <Box>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                        >
                          <Grid>
                            <Typography variant="h5">Attendance</Typography>
                          </Grid>
                          <Grid>
                            <Tooltip title="Show Permission">
                              <IconButton
                                onClick={() => openGefeanceModal("Attendance")}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          direction="row"
                          spacing={3}
                          alignItems="center"
                        >
                          {/* <Grid item spacing={3}>
                                                    <div className="field_box">
                                                        <Autocomplete
                                                            size="small"
                                                            id="header"
                                                            className="select_box_forCompanyWise"
                                                            options={userList || []}
                                                            getOptionLabel={(designation) =>
                                                                designation.name ? `${designation.name}(${designation.empCode})` : AutoSelectUser
                                                            }
                                                            getOptionSelected={(option, value) =>
                                                                option.name ===
                                                                (value != null && value.name != null ? value.name : "")
                                                            }
                                                            //filterSelectedOptions
                                                            disablePortal={true}
                                                            fullWidth
                                                            onChange={(event, newValue) => {
                                                                setAutoSelectUser(newValue);
                                                            }}
                                                            value={AutoSelectUser}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    placeholder=" Select User"
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </Grid> */}
                          <Grid item>
                            <div className="field_box">
                              <Autocomplete
                                size="small"
                                className="select_box_forCompanyWise"
                                multiple
                                limitTags={1}
                                id="multiple-limit-tags"
                                //options={userList || []}
                                options={
                                  [
                                    {
                                      id: "All",
                                      name: "All",
                                      empcode: "Select All Id",
                                      value: "All",
                                    },
                                    ...userListByCompanyForAttendance,
                                  ] || []
                                }
                                getOptionLabel={(option) =>
                                  `${option.name}(${option.empcode})`
                                }
                                disablePortal={true}
                                fullWidth
                                onChange={(event, newValue) => {
                                  getuserOnchange1(newValue, "Attendance");
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    placeholder="Multi Select User"
                                  />
                                )}
                              />
                            </div>
                          </Grid>
                          <Grid item>
                            <div className="field_box">
                              <Autocomplete
                                size="small"
                                className="select_box_forCompanyWise"
                                limitTags={1}
                                id="multiple-limit-tags"
                                options={AttendensSelectType || []}
                                getOptionLabel={(option) => `${option.name}`}
                                disablePortal={true}
                                fullWidth
                                onChange={(event, newValue) => {
                                  setAttendensSelectTypeId(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    placeholder="Attendance Select Type"
                                  />
                                )}
                              />
                            </div>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                          >
                            <div className="field_box">
                              <div
                                className="field_box_btn1"
                                onClick={fetchUserCongiguration}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                Save User
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
        </Grid>

        {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
          <Grid className="CompanyBox">
            <Accordion className="main_accoardian" defaultExpanded={true}>
              <AccordionSummary
                className="accordianHeader"
                expandIcon={
                  <AddCircleIcon fontSize="large" style={{ color: "white" }} />
                }
                aria-controls="panel1a-content"
                style={{
                  background: "rgb(10 166 141)",
                  borderRadius: "10px 10px 0px 0px",
                  overflow: "hidden",
                }}
              >
                <Grid>
                  <Grid>
                    <h3
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      User Base Geofence:-
                    </h3>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Box>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid>
                        <Typography variant="h5">Geofence</Typography>
                      </Grid>
                      <Grid>
                        <Tooltip title="Show Permission">
                          <IconButton
                            onClick={() => openGefeanceModal("Geofence")}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      //justifyContent="center"
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceLat}
                          id="outlined-basic"
                          label="Geofence Start Lat "
                          name="Geofence Start Lat"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setGeofancelat(e.target.value)}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceLong}
                          id="outlined-basic"
                          label="Geofence Start Long "
                          name="Geofence Start Long"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setGeofancelong(e.target.value)}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceDistance}
                          id="outlined-basic"
                          label="Start Distance"
                          name="Start Distance"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setGeofanceDistance(e.target.value)}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceLatEnd}
                          id="outlined-basic"
                          label="Geofence End Lat "
                          name="Geofence End Lat"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setGeofancelatEnd(e.target.value)}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceLongEnd}
                          id="outlined-basic"
                          label="Geofence End Long "
                          name="Geofence End Long"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setGeofancelongEnd(e.target.value)}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          required
                          value={geofanceDistanceEnd}
                          id="outlined-basic"
                          label="End Distance"
                          name="Distance"
                          variant="outlined"
                          size="small"
                          onChange={(e) =>
                            setGeofanceDistanceEnd(e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <div className="field_box">
                          <Autocomplete
                            size="small"
                            className="select_box"
                            multiple
                            limitTags={1}
                            id="multiple-limit-tags"
                            options={
                              [
                                {
                                  userId: "All",
                                  name: "All",
                                  empCode: "Select All Id",
                                  value: "All",
                                },
                                ...userList,
                              ] || []
                            }
                            getOptionLabel={(option) =>
                              `${option.name}(${option.empCode})`
                            }
                            disablePortal={true}
                            fullWidth
                            onChange={(event, newValue) => {
                              getuserOnchange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                margin="dense"
                                placeholder="User"
                              />
                            )}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <div className="field_box">
                        <div
                          className="field_box_btn1"
                          onClick={fetchGeofenceData}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Save Geofence
                        </div>
                      </div>
                    </Grid>
                  </Box>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
        {/* {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
            <Grid className="CompanyBox">
              <Accordion className="main_accoardian" defaultExpanded={true}>
                <AccordionSummary
                  className="accordianHeader"
                  expandIcon={
                    <AddCircleIcon
                      fontSize="large"
                      style={{ color: "white" }}
                    />
                  }
                  aria-controls="panel1a-content"
                  style={{
                    background: "rgb(10 166 141)",
                    borderRadius: "10px 10px 0px 0px",
                    overflow: "hidden",
                  }}
                >
                  <Grid>
                    <Grid>
                      <h3
                        style={{
                          color: "#fff",
                          marginLeft: "10px",
                          padding: "10px 2px",
                        }}
                      >
                        Stand live Tracking Configuration:-
                      </h3>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className="accoardian_body">
                  <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
                    <Grid>
                      <Box>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                        >
                          <Grid>
                            <Typography variant="h5">Show Stand live Tracking</Typography>
                          </Grid>
                          <Grid>
                            <Tooltip title="Show Stand live Tracking">
                              <IconButton
                                onClick={() => openGefeanceModal("StandliveTracking")}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          direction="row"
                          spacing={3}
                          alignItems="center"
                        >
                          
                          <Grid item>
                            <div className="field_box">
                              <Autocomplete
                                size="small"
                                className="select_box_forCompanyWise"
                                multiple
                                limitTags={1}
                                id="multiple-limit-tags"
                                //options={userList || []}
                                options={
                                  [
                                    {
                                      userId: "All",
                                      name: "All",
                                      empCode: "Select All Id",
                                      value: "All",
                                    },
                                    ...userList,
                                  ] || []
                                }
                                getOptionLabel={(option) =>
                                  `${option.name}(${option.empCode})`
                                }
                                disablePortal={true}
                                fullWidth
                                onChange={(event, newValue) => {
                                  getuserOnchange1(newValue,"StandLive");
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    placeholder="Multi Select User"
                                  />
                                )}
                              />
                            </div>
                          </Grid>

                          <Grid item>
                          <Switch
                                checked={standLiveActive}
                                onChange={(e) =>
                                  setStandLiveActive(e.target.checked)
                                }
                                color="secondary"
                              />
                          </Grid>

                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                          >
                            <div className="field_box">
                              <div
                                className="field_box_btn1"
                                onClick={fetchUserCongiguration}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                Save User
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )} */}

        {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
          <Grid className="CompanyBox">
            <Accordion className="main_accoardian" defaultExpanded={true}>
              <AccordionSummary
                className="accordianHeader"
                expandIcon={
                  <AddCircleIcon fontSize="large" style={{ color: "white" }} />
                }
                aria-controls="panel1a-content"
                style={{
                  background: "rgb(10 166 141)",
                  borderRadius: "10px 10px 0px 0px",
                  overflow: "hidden",
                }}
              >
                <Grid>
                  <Grid>
                    <h3
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      Distance Calculation Configuration :-
                    </h3>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Box>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      {/* <Grid>
                        <Typography variant="h5">Geofence</Typography>
                      </Grid>
                      <Grid>
                        <Tooltip title="Show Permission">
                          <IconButton
                            onClick={() => openGefeanceModal("Geofence")}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid> */}
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      spacing={3}
                      alignItems="center"
                      style={{ marginTop: "2px" }}
                    >
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          // required
                          value={distanceEndTime}
                          id="outlined-number"
                          label="Day End Time"
                          type="time"
                          name="Day End Time"
                          variant="outlined"
                          size="small"
                          onChange={(e) => setDistanceEndTime(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item spacing={3}>
                        <Switch
                          checked={distanceCalculate}
                          onChange={(e) =>
                            setDistanceCalculate(e.target.checked)
                          }
                          color="secondary"
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <div className="field_box">
                        <div
                          className="field_box_btn1"
                          onClick={() => fetchDitanceConfiguration("distance")}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Distance Update
                        </div>
                      </div>
                    </Grid>
                  </Box>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}

        {(CompanyConfigurationData.length > 0 || OnyShowHeader === true) && (
          <Grid className="CompanyBox">
            <Accordion className="main_accoardian" defaultExpanded={true}>
              <AccordionSummary
                className="accordianHeader"
                expandIcon={
                  <AddCircleIcon fontSize="large" style={{ color: "white" }} />
                }
                aria-controls="panel1a-content"
                style={{
                  background: "rgb(10 166 141)",
                  borderRadius: "10px 10px 0px 0px",
                  overflow: "hidden",
                }}
              >
                <Grid>
                  <Grid>
                    <h3
                      style={{
                        color: "#fff",
                        marginLeft: "10px",
                        padding: "10px 2px",
                      }}
                    >
                      Location Tracking Configuration :-
                    </h3>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Box>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    ></Grid>

                    <Grid
                      container
                      direction="row"
                      spacing={3}
                      alignItems="center"
                      style={{ marginTop: "2px" }}
                    >
                      <Grid item spacing={3}>
                        <CustomInputField
                          sx={{ width: "100%", margin: "0px !important" }}
                          // required
                          value={locationEndTime}
                          // autoFocus

                          id="outlined-number"
                          label="Location Tracking Interval"
                          // placeholder="Location Tracking Interval"
                          type="number"
                          name="Location Tracking Interval"
                          // variant="outlined"
                          size="small"
                          onChange={(e) => setLocationEndTime(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                      <Grid item spacing={3}>
                        <Switch
                          checked={locationActive}
                          onChange={(e) => setLocationActive(e.target.checked)}
                          color="secondary"
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      {(locationActiveActual || locationActive) && (
                        <div className="field_box">
                          <div
                            className="field_box_btn1"
                            onClick={() =>
                              fetchDitanceConfiguration("location")
                            }
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            Location Update
                          </div>
                        </div>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}

        {(sortedList.length > 0 || OnyShowHeader === true) && (
          <Grid>
            <Companywiseclientstatus
              sortedList={sortedList}
              setSortedList={setSortedList}
              fetchcompanyclientstatusDataList={
                fetchcompanyclientstatusDataList
              }
              companyId={companyId}
              setCompanyId={setCompanyId}
            />
          </Grid>
        )}
      </main>
    </div>
  );
}

export default ConfiguartionUpdate;
